var _defs, _g, _rect, _g2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 284.84 46.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke:#000;}.cls-1,.cls-7,.cls-9{fill:#fff;}.cls-1,.cls-8{stroke-width:.03px;}.cls-2,.cls-10{stroke-width:.24px;}.cls-2,.cls-10,.cls-11,.cls-12{fill:#000;}.cls-13{fill:#2c398a;}.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-11,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-9,.cls-12,.cls-45,.cls-46{stroke-width:0px;}.cls-13,.cls-12,.cls-45{fill-rule:evenodd;}.cls-14{fill:url(#Degradado_sin_nombre_19);}.cls-15{fill:#629c51;}.cls-47{clip-path:url(#clippath);}.cls-16{fill:#a22f2b;}.cls-17{fill:none;}.cls-18{fill:#f2b844;}.cls-3{stroke-width:.04px;}.cls-3,.cls-4,.cls-5{fill:#333;}.cls-19{fill:#417168;}.cls-20{fill:#27437f;}.cls-4{stroke-width:.04px;}.cls-10{stroke:#fff;}.cls-21{fill:#2b317b;}.cls-22{fill:#eecd50;}.cls-23{fill:#f2e959;}.cls-24{fill:#f6d86c;}.cls-48{clip-path:url(#clippath-1);}.cls-49{clip-path:url(#clippath-4);}.cls-50{clip-path:url(#clippath-3);}.cls-51{clip-path:url(#clippath-2);}.cls-52{clip-path:url(#clippath-7);}.cls-53{clip-path:url(#clippath-8);}.cls-54{clip-path:url(#clippath-6);}.cls-55{clip-path:url(#clippath-5);}.cls-56{clip-path:url(#clippath-9);}.cls-5{stroke-width:.05px;}.cls-25{fill:#4a60a5;}.cls-26{fill:#009058;}.cls-27{fill:#337845;}.cls-6{stroke-width:.04px;}.cls-6,.cls-31,.cls-8{fill:#f7d849;}.cls-28{fill:#bb3430;}.cls-57{clip-path:url(#clippath-20);}.cls-58{clip-path:url(#clippath-21);}.cls-59{clip-path:url(#clippath-24);}.cls-60{clip-path:url(#clippath-23);}.cls-61{clip-path:url(#clippath-22);}.cls-62{clip-path:url(#clippath-25);}.cls-63{clip-path:url(#clippath-27);}.cls-64{clip-path:url(#clippath-28);}.cls-65{clip-path:url(#clippath-26);}.cls-66{clip-path:url(#clippath-29);}.cls-67{clip-path:url(#clippath-34);}.cls-68{clip-path:url(#clippath-35);}.cls-69{clip-path:url(#clippath-36);}.cls-70{clip-path:url(#clippath-37);}.cls-71{clip-path:url(#clippath-33);}.cls-72{clip-path:url(#clippath-32);}.cls-73{clip-path:url(#clippath-30);}.cls-74{clip-path:url(#clippath-31);}.cls-75{clip-path:url(#clippath-14);}.cls-76{clip-path:url(#clippath-13);}.cls-77{clip-path:url(#clippath-10);}.cls-78{clip-path:url(#clippath-15);}.cls-79{clip-path:url(#clippath-17);}.cls-80{clip-path:url(#clippath-16);}.cls-81{clip-path:url(#clippath-19);}.cls-82{clip-path:url(#clippath-11);}.cls-83{clip-path:url(#clippath-18);}.cls-29{fill:#54924f;}.cls-30{fill:#f0e054;}.cls-32{fill:#f2e95b;}.cls-33{fill:url(#linear-gradient);opacity:.85;}.cls-34{fill:#efd152;}.cls-35{fill:#568f5a;}.cls-36{fill:#72b7e3;}.cls-37{fill:#5b904c;}.cls-38{fill:#b93335;}.cls-39{fill:#c53c33;}.cls-40{fill:#ad3138;}.cls-7{stroke-width:.05px;}.cls-41{fill:#b3b2b3;}.cls-42{fill:#2e337a;}.cls-43{fill:#2b3977;}.cls-44{fill:#dd5044;}.cls-45{fill:#3f9150;}.cls-46{fill:#b03142;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -344.48,
    y: 0,
    width: 284.84,
    height: 46.86,
    rx: 23.43,
    ry: 23.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 102.49,
    y: -0.61,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 102.49,
    y: -0.61,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 102.49,
    y: -0.61,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 144.15,
    y: -0.58,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 144.15,
    y: -0.58,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 186,
    y: -0.58,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 186,
    y: -0.58,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 227.84,
    y: -0.58,
    width: 41.7,
    height: 24.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 227.84,
    y: -0.58,
    width: 41.7,
    height: 24.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 269.55,
    y: -0.58,
    width: 41.84,
    height: 24.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -34.3,
    y: 23.85,
    width: 41.7,
    height: 24.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 7.4,
    y: 23.85,
    width: 41.84,
    height: 24.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 49.25,
    y: 23.85,
    width: 41.85,
    height: 24.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 247.48,
    y: 23.82,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 247.48,
    y: 23.82,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 247.48,
    y: 23.82,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_19",
    x1: 183.89,
    y1: 95.25,
    x2: 100.96,
    y2: -48.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff48d7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 0,
    y: 0,
    width: 284.84,
    height: 46.86,
    rx: 23.43,
    ry: 23.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 39.89,
    y: -0.56,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 39.89,
    y: -0.56,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 39.89,
    y: -0.56,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 81.55,
    y: -0.54,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 81.55,
    y: -0.54,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 123.39,
    y: -0.54,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 123.39,
    y: -0.54,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 165.24,
    y: -0.54,
    width: 41.7,
    height: 24.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 165.24,
    y: -0.54,
    width: 41.7,
    height: 24.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 206.94,
    y: -0.54,
    width: 41.84,
    height: 24.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 248.79,
    y: -0.54,
    width: 41.85,
    height: 24.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 184.82,
    y: 23.82,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 184.82,
    y: 23.82,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 184.82,
    y: 23.82,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 226.49,
    y: 23.85,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 226.49,
    y: 23.85,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 268.33,
    y: 23.85,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 268.33,
    y: 23.85,
    width: 41.85,
    height: 24.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -13.36,
    y: 23.9,
    width: 41.85,
    height: 24.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 183.89,
    y1: 95.25,
    x2: 100.96,
    y2: -48.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ff9d45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ff48d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff48d7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -344.48,
    y: 72.93,
    width: 284.84,
    height: 46.86,
    rx: 23.43,
    ry: 23.43
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 62.28,
    y: -0.55,
    width: 40.21,
    height: 24.34
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "62.28 2.09 62.28 21.27 76.64 11.67 62.28 2.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "102.49 9.27 81.64 9.27 66.79 -.55 62.28 -.55 62.28 2.37 76.12 11.67 62.28 20.96 62.28 23.79 67.01 23.79 81.34 14.11 102.49 14.11 102.49 9.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "102.49 -.55 69.75 -.55 81.89 7.47 102.49 7.47 102.49 -.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "102.49 15.81 81.89 15.81 69.81 23.79 102.49 23.79 102.49 15.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "62.28 4.4 62.28 18.97 73.19 11.67 62.28 4.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NAMIBIA"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "102.49 -.61 102.49 23.79 144.34 -.61 102.49 -.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "144.34 -.61 102.49 23.79 144.34 23.79 144.34 -.61"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "104.68 27.55 100.3 20.04 142.15 -4.37 146.53 3.14 104.68 27.55 104.68 27.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "104.13 26.61 100.85 20.98 142.69 -3.43 145.98 2.2 104.13 26.61 104.13 26.61"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "114.85 8.13 113.05 7.82 113.36 9.62 111.95 8.46 111.32 10.17 110.69 8.46 109.29 9.62 109.6 7.82 107.8 8.13 108.96 6.73 107.25 6.1 108.96 5.47 107.8 4.07 109.6 4.37 109.29 2.58 110.69 3.74 111.32 2.03 111.95 3.74 113.36 2.58 113.05 4.37 114.85 4.07 113.68 5.47 115.39 6.1 113.68 6.73 114.85 8.13"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M113.76,6.1c0,1.35-1.09,2.44-2.44,2.44s-2.44-1.09-2.44-2.44c0-1.35,1.09-2.44,2.44-2.44,1.35,0,2.44,1.09,2.44,2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M113.36,6.1c0,1.12-.91,2.03-2.03,2.03-1.12,0-2.03-.91-2.03-2.03,0-1.12.91-2.03,2.03-2.03s2.03.91,2.03,2.03"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ZIMBABWE"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 144.15,
    y: -0.58,
    width: 41.85,
    height: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 144.15,
    y: 2.9,
    width: 41.85,
    height: 17.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 144.15,
    y: 6.39,
    width: 41.85,
    height: 10.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 144.15,
    y: 9.88,
    width: 41.85,
    height: 3.49
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "144.15 -.58 144.15 23.82 145.04 23.82 161.3 11.62 145.04 -.58 144.15 -.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "144.15 -.58 144.15 23.82 160.41 11.62 144.15 -.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "150.74 5.42 147.99 10.98 152.16 13.04 150.74 5.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "150.74 5.42 153.48 10.98 149.31 13.04 150.74 5.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "150.74 5.42 148.66 11.26 153.04 12.82 150.74 5.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "150.74 5.42 152.81 11.26 148.43 12.82 150.74 5.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "156.63 9.7 150.5 8.81 149.83 13.41 156.63 9.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "144.84 9.7 150.97 8.81 151.64 13.41 144.84 9.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "156.63 9.7 150.43 9.53 150.31 14.18 156.63 9.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "144.84 9.7 151.04 9.53 151.16 14.18 144.84 9.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "153.86 15.93 152.78 10.71 150.17 11.26 153.86 15.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "153.86 15.93 149.24 13.28 150.57 10.97 153.86 15.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "147.61 15.93 152.23 13.28 150.9 10.97 147.61 15.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "147.61 15.93 148.69 10.71 151.3 11.26 147.61 15.93"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M152.86,15.49c0-.78.14-1.53.42-2.33.13-.36.47-1.1.56-1.21,0-.01.15.02.32.06.34.1.44.08.44-.08,0-.09-.35-.4-2.06-1.83-1.15-.96-2.1-1.72-2.14-1.72s-.09-.03-.1-.06c-.01-.03-.07-.4-.12-.83-.06-.43-.14-.84-.17-.93-.11-.26-.33-.39-.69-.41-.27-.02-.33,0-.51.1-.12.07-.27.12-.37.12-.2,0-.37.16-.37.35v.13s.3,0,.3,0c.16,0,.25,0,.18.01-.21.04-.13.34.12.43.27.1.26.04.26,1.3,0,1.03,0,1.18-.08,1.42-.11.35-.11.87,0,1.21.04.14.08.27.08.29,0,.02-.13.19-.28.38-.28.34-.46.7-.46.96,0,.06-.04.16-.08.22-.1.15-.11.4,0,.5.11.1.54,1.89.54,2.23,0,.12.02.12.68-.02.53-.11,1.79-.14,2.43-.05.29.04.64.11.76.14.39.11.37.13.37-.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M152.32,15.75c-.58-.14-1.24-.19-1.98-.16-.37.02-.77.05-.87.07l-.19.04-.05-.32c-.03-.17-.04-.32-.03-.33,0,0,.19-.04.4-.07.74-.11,2.31-.07,3.04.08l.13.03v.38c0,.28-.01.38-.05.38-.03,0-.21-.04-.4-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M148.7,15.78c0-.09-.23-1.19-.33-1.58-.07-.26-.12-.5-.12-.52,0-.02.06,0,.14.06.08.05.17.1.22.1.21,0,.33.32.51,1.4.03.15.05.32.07.37.02.09,0,.11-.19.15-.23.06-.29.06-.29.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M152.72,14.93s0-.07.04-.1c.05-.05.06-.04.06.02,0,.08-.07.14-.1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M149.41,14.76c.11-.12.11-.12.2-.04.08.08.08.09.01.12-.04.02-.13.03-.2.04h-.12s.11-.12.11-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M152.13,14.83s.05-.08.1-.11c.07-.05.09-.04.15.05l.07.11h-.17c-.11,0-.16-.02-.15-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M152.49,14.76c-.05-.07-.08-.13-.07-.14,0,0,.09,0,.19.02l.18.03-.1.11-.1.11-.09-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M149.13,14.77c-.03-.09.04-.16.16-.16.09,0,.09,0-.03.13-.09.1-.1.1-.13.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M150.09,14.69l.11-.13.11.1c.06.06.11.11.12.11,0,0-.09.02-.21.02l-.23.02.11-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.55,14.8l-.14-.03.1-.1.1-.1.12.14c.13.15.12.16-.18.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M149.73,14.68l-.1-.12h.15c.08,0,.18-.01.22-.03.06-.03.05,0-.03.12-.05.08-.11.14-.12.14s-.07-.05-.12-.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M150.78,14.65l.12-.14.12.12c.06.07.12.13.12.14s-.11.01-.23.01h-.23s.12-.14.12-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.87,14.68l-.1-.12h.19c.21,0,.23.03.12.15-.1.1-.1.1-.21-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M150.43,14.63l-.1-.11h.22s.22,0,.22,0l-.1.11c-.12.14-.13.14-.25,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.17,14.63l-.1-.11h.22s.22,0,.22,0l-.1.11c-.12.14-.13.14-.25,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M152.49,14.51c-.1-.02-.51-.06-.91-.09-.69-.06-1.55-.03-2.31.08-.16.02-.2.01-.2-.04,0-.12.83-.2,2.1-.2.62,0,1.26.02,1.41.04.26.03.28.05.28.15,0,.12-.03.13-.37.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M149.29,14.12c.08-.09.17-.16.19-.16s.08.05.13.11l.09.11-.2.03c-.11.02-.24.04-.28.05-.06.01-.04-.02.07-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M149,14.15c-.03-.09-.02-.12.05-.15.05-.02.12-.03.16-.02.07.01.06.03-.05.15l-.13.13-.04-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M152.82,14.2s.03-.05.06-.07c.04-.02.05,0,.04.04-.03.07-.1.09-.1.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M150.05,14.04c.06-.08.11-.14.11-.15,0,0,.06.05.13.12l.13.13-.24.02-.24.02.11-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M152.25,14.16l-.18-.02.13-.12.13-.12.1.11c.11.12.13.19.05.17-.03,0-.13-.02-.23-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M149.71,14.03l-.12-.11.2-.03c.11-.02.2-.03.21-.02,0,0-.03.07-.08.14l-.09.12-.12-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.51,14.11l-.1-.03.1-.11c.09-.09.11-.1.17-.05.04.03.08.1.11.14.03.07.02.08-.07.08-.06,0-.16-.02-.21-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M152.55,14l-.12-.14.1.03c.06.02.18.03.27.03h.16s-.12.11-.12.11c-.07.06-.13.11-.15.12-.01,0-.08-.06-.14-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M150.44,14c-.05-.06-.09-.12-.09-.14,0-.02.1-.03.23-.03h.23s-.08.1-.08.1c-.14.17-.2.18-.3.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M150.82,13.99c.13-.13.18-.13.26.02.06.1.06.1-.16.1h-.22s.12-.12.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.84,13.96l-.1-.14h.1c.06,0,.16.01.23.03l.13.03-.12.11c-.06.06-.12.11-.13.11,0,0-.06-.06-.11-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.17,13.94l-.1-.12h.22s.22,0,.22,0l-.1.12c-.12.14-.13.14-.25,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M148.97,13.79s.05-.18.08-.31l.05-.23.45-.25c.25-.14.53-.31.62-.39.09-.08.18-.16.21-.17.06-.04,1.26.05,1.79.13.41.07,1.12.21,1.14.23,0,0-.06.21-.14.46-.08.25-.16.48-.17.52-.01.05-.06.05-.2.03-.68-.11-2.63-.1-3.38.02-.43.07-.49.06-.45-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M152.41,13.51c.27-.3.08-.78-.29-.78-.24,0-.41.19-.41.46,0,.42.44.62.7.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.97,13.5c-.22-.12-.21-.53.02-.63.23-.1.46.06.46.32,0,.25-.27.43-.48.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M150.76,13.48c.25-.23.19-.64-.1-.78-.19-.09-.4-.02-.51.18-.12.22-.1.38.06.56.18.2.37.21.56.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M150.36,13.46c-.3-.14-.2-.69.13-.69.32,0,.43.5.14.67-.13.08-.15.08-.27.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M148.78,13.67c.06-.17.05-.39-.01-.39-.03,0-.05.06-.05.16,0,.09-.02.19-.05.22-.05.05-.05.01-.03-.21.01-.15,0-.26-.01-.26-.04,0-.11.22-.13.41q-.02.11-.05-.02c-.03-.1-.01-.17.05-.31.05-.09.09-.23.09-.31,0-.11.08-.22.46-.63.25-.27.55-.61.65-.75.18-.24.19-.27.19-.52,0-.14-.02-.27-.03-.29-.05-.05-.11.22-.09.37.02.14,0,.18-.27.52-.16.2-.43.51-.6.68-.32.32-.43.49-.43.65,0,.05-.04.18-.08.29-.04.11-.07.22-.06.25.01.03,0,.03-.03,0-.04-.04-.04-.1,0-.25.02-.11.03-.22.02-.24-.04-.08-.1.02-.12.24-.02.12-.04.21-.06.2-.06-.04-.04-.27.03-.38.04-.06.08-.2.1-.32.05-.32.18-.58.47-.92.14-.18.26-.33.26-.33,0,0-.04-.14-.09-.29-.11-.34-.12-.87-.02-1.19.1-.33.32-.67.65-1.02.35-.36.68-.58.84-.55.14.02,4.13,3.36,4.13,3.45,0,.04-.03.07-.07.06-.04,0-1.05-.31-2.25-.68-1.92-.6-2.19-.69-2.28-.8-.12-.15-.12-.38-.01-.54.05-.06.08-.14.08-.18,0-.1-.2.16-.24.31-.05.18.04.47.16.57.05.04.41.17.81.3.68.21.72.24.76.36.09.29-.2.62-.61.72-.13.03-.3.12-.42.21-.46.37-.79.59-1.06.72-.16.07-.31.16-.34.19-.03.03-.07.16-.09.3-.05.28-.07.33-.15.33-.05,0-.05-.03-.02-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M152.96,12.61c-.42-.1-1.09-.2-1.77-.26l-.65-.06.25-.1c.14-.05.33-.15.43-.21.16-.1.23-.11.47-.09.37.03.62-.04.71-.21.04-.07.08-.13.08-.14,0,0,.3.07.65.18l.64.2-.12.23c-.07.13-.15.3-.19.38-.08.17-.1.17-.48.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.51,11.78s-.03-.05,0-.11c.03-.05.06-.07.08-.03.04.07-.03.19-.09.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.67,11.77c0-.06.03-.06.06,0,.01.03,0,.05-.02.05s-.04-.02-.04-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.87,11.74s.02-.06.04-.04c.05.04.05.11,0,.11-.02,0-.04-.03-.04-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M152.07,11.74s-.03-.06-.03-.1c0-.05.01-.06.05-.02.02.03.04.07.03.1,0,.03-.03.04-.05.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.74,11.65s-.03-.07-.03-.1c0-.05.01-.06.05-.02.03.03.04.08.03.1,0,.03-.03.04-.05.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M152.22,11.63c-.04-.08,0-.1.06-.02.03.04.04.07,0,.07-.02,0-.06-.02-.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.89,11.54s0-.05.02-.07c.02-.02.04,0,.04.04,0,.08-.02.09-.06.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M152.08,11.47s.02-.06.04-.04c.05.04.05.11,0,.11-.02,0-.04-.03-.04-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.58,11.43c0-.08.02-.09.06-.03.01.02,0,.05-.02.07-.02.02-.04,0-.04-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M151.75,11.37s.02-.06.04-.04c.05.04.05.12,0,.12-.02,0-.04-.03-.04-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M148.98,9.17c-.01-.2-.01-.66,0-1.03.02-.76,0-.83-.23-.92-.19-.07-.26-.12-.26-.21,0-.06.04-.07.25-.04.22.03.25.02.24-.05-.02-.12-.31-.21-.61-.19-.24.01-.27,0-.25-.06.03-.14.17-.23.37-.25.11-.01.27-.06.35-.11.13-.08.22-.09.46-.08.54.03.64.19.78,1.22.05.4.1.77.1.82,0,.07-.07.15-.26.29-.28.2-.64.56-.81.82l-.1.15-.02-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M149.38,6.77c.06-.08.07-.11.03-.21-.06-.14-.13-.11-.1.05.02.09,0,.12-.07.12s-.09-.03-.09-.14,0-.13-.06-.08c-.08.07-.08.18,0,.28.09.11.19.11.28,0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "MOZAMBIQUE"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 186,
    y: -0.58,
    width: 41.85,
    height: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 186,
    y: -0.58,
    width: 41.85,
    height: 8.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 186,
    y: -0.58,
    width: 41.85,
    height: 7.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 186,
    y: 15.42,
    width: 41.85,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 186,
    y: 16.19,
    width: 41.85,
    height: 7.63
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "186 -.58 186 23.82 202.02 11.62 186 -.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "194.31 16.19 191.34 14.01 188.36 16.19 189.52 12.69 186.53 10.54 190.21 10.55 191.34 7.04 192.46 10.55 196.15 10.54 193.16 12.69 194.31 16.19"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M188.75,13.75h2.14c.17.19.56.27.92,0,.67-.37,1.97,0,1.97,0l.26-.27-.62-2.05-.22-.24s-.48-.29-1.39-.19c-.91.1-1.23-.03-1.23-.03,0,0-.8.09-1.02.21-.02.02-.26.26-.26.26l-.54,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M191.33,13.95h0c-.18,0-.35-.07-.45-.18h-2.12s.52-2.34.52-2.34c0-.01.24-.25.27-.27.23-.12,1-.21,1.04-.21.02,0,.34.12,1.23.03.91-.1,1.39.19,1.41.2l.23.24.63,2.06-.26.3s-.61-.16-1.18-.16c-.33,0-.6.05-.79.16-.16.12-.33.18-.51.18h0ZM190.9,13.72c.11.11.27.18.43.18h0c.16,0,.33-.06.48-.17.2-.11.48-.17.82-.17.58,0,1.17.17,1.17.17l.23-.26-.63-2.02-.22-.23h0s-.49-.28-1.37-.19c-.91.1-1.24-.03-1.24-.03,0,0-.79.1-1,.21-.02.02-.25.25-.25.25l-.54,2.31,2.12-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M191.31,13.95c-.15,0-.3-.06-.45-.16.04-.08.19-.24.47-.38-.81-.32-2.13-.16-2.15-.16-.02,0-.03,0-.03-.02,0-.01,0-.03.02-.03.07,0,1.38-.17,2.2.19.4-.19,1.05-.34,1.99-.21.01,0,.02.02.02.03,0,.02-.01.03-.03.02-.92-.13-1.54.01-1.92.18.17.08.31.18.41.32-.19.15-.36.22-.53.22h0ZM191.4,13.43c-.35.16-.49.34-.49.35.29.18.57.18.91-.05-.1-.12-.24-.22-.41-.3h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "191.38 13.43 191.36 11.17 191.4 11.17 191.38 13.43 191.38 13.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "193.61 12.99 193.18 11.21 193.22 11.2 193.61 12.99 193.61 12.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M189.36,12.13s0,0,0,0c-.01,0-.02-.02-.02-.03l.21-.92s.02-.02.03-.02c.01,0,.02.02.02.03l-.21.92s-.01.02-.02.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M187.36,14l.5.59c.06.03.11.03.17,0l.75-.9.31-.39c.05-.06.06-.12.06-.18l.6-.53s.08,0,.13.01c-.06-.01-.1-.04-.06-.11l.13-.1.1.13s-.15.19-.16.19h-.16s-.31.28-.31.28l.14.12.21.57.25-.18-.16-.58.36-.39-.13-.21.09-.12s1.24.78,1.72.57c.01,0,.03-.56.03-.56,0,0-1.29-.13-1.31-.39-.03-.25.28-.28.28-.28l-.13-.19.03-.1.22.28.51-.43,2.99,3.41c.16-.07.2-.11.21-.27,0,0-2.93-3.36-2.93-3.36l.22-.24s.06-.07.06-.15l.34-.3c.1.04.17.1.22.18l.95-.8s.1.05.15.02l1.56-1.5-1.7,1.2-.06-.04s.06-.06,0-.15c-.07-.08-.16.07-.18.07s-.25-.08-.3-.19l-.02.27-.43.4-.33-.02-.48.46-.06.18.07.15s-.25.22-.25.21-.05-.07-.05-.07l.22-.2.03-.13-.07-.11s-.3.31-.32.28c-.02-.03-.81-.91-.81-.91l.05-.16-.51-.55c-.19-.06-.48-.07-.54.33-.05.09-.43.02-.43.02l-.21.05-1.18,1.67.66.79,1.34-1.7.04-.48.28.31c.09.01.18.01.27-.03l.8.89-.13.13s.08.08.12.13c.04-.03.09-.07.13-.1.02.02.04.06.05.08-.07.04-.11.09-.18.12-.11-.07-.21-.16-.2-.3l-.45.37-.02.07-1.33,1.11-.12.02-.03.34.87-.72v-.1s.09.07.09.07l.67-.54s.04.06.03.06c-.02,0-.6.54-.6.54l-.02.06-.1.09-.06-.04-.81.72h-.12s-.45.45-.45.45c-.12,0-.22.02-.31.09l-.8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M187.95,14.64s-.06,0-.1-.03l-.51-.6.81-.75c.1-.07.2-.08.33-.1l.43-.44h.14s.79-.72.79-.72l.09.04.08-.13c.45-.42.57-.52.6-.55h0s-.02-.01-.03-.03l-.64.54-.12-.08.04.08-.88.74v-.37s.13-.04.13-.04l1.32-1.1v-.06s.46-.39.46-.39c.03.15.13.23.23.29,0-.02.03-.04.06-.06.03-.02.06-.04.09-.06h-.04s-.12.06-.12.06l-.15-.14.13-.16-.8-.85s-.15.05-.25.04l-.3-.32v.47s-1.35,1.72-1.35,1.72l-.7-.79,1.18-1.7.22-.06s.16.03.28.03c.11,0,.13-.02.13-.03.07-.47.43-.39.57-.34l.52.56-.04.19h0s.78.86.8.89c.01-.02.15-.16.22-.22.03-.03.06-.06.07-.06l.08.09.03-.09.48-.47h.35s.41-.39.41-.39v-.26c.1.08.31.16.33.16.03-.05.08-.1.13-.1,0,0,.06.03.06.03.05.07.03.1.02.14l.04.05,1.67-1.2s.03,0,.03,0c0,0,0,.02,0,.03l-1.56,1.5c-.07.04-.15.02-.19-.02l-.91.8c-.1-.09-.16-.14-.25-.17l-.32.29c0,.07,0,.09-.06.15l-.22.24h0s2.9,3.3,2.93,3.33c0,.2-.05.24-.22.31l-3.02-3.41-.47.44-.26-.29v.1s.14.17.14.17c-.02.04-.17.06-.24.15-.03.04-.05.09-.04.15.02.17.8.31,1.29.37,0,.61,0,.61-.03.61-.05.02-.12.03-.2.03-.56,0-1.5-.59-1.53-.61l-.06.11.14.18-.36.42.17.56-.26.21-.24-.58-.13-.11.31-.32h.18s.08-.11.14-.19l-.1-.1-.1.11s0,.05.05.06c.01,0,.02.02.02.03,0,.01-.02.02-.03.02h-.13s-.58.51-.58.51c.01.03,0,.1-.06.18l-1.06,1.29s-.07.03-.1.03h0ZM189.84,12.05l-.78.72h-.14s-.43.45-.43.45c-.14.02-.23.03-.32.09l-.8.71.51.56s.08.03.13,0l1.05-1.28c.05-.06.06-.12.05-.16l.61-.55h.05s0,0,0,0c0-.02,0-.05.02-.09l.14-.11.14.14c-.16.23-.17.23-.18.23h-.16s-.3.28-.3.28l.14.08.21.58.22-.19-.17-.56.36-.41-.14-.18.09-.15h0s1,.6,1.54.6c.07,0,.14-.01.19-.03,0-.02,0-.34.01-.54-.11.01-1.28-.12-1.32-.39,0-.07,0-.14.05-.19.09-.11.25-.12.26-.12l-.15-.15.03-.13.27.28.47-.44,3.02,3.41c.13-.07.15-.1.16-.25-.01,0-.24-.26-2.92-3.34l.23-.27s.05-.06.05-.13l.35-.32c.12.03.2.09.26.18l.91-.81s.08.03.11.03l1.34-1.26-1.41.99-.09-.04s0-.06,0-.07c.01-.02.02-.04-.01-.08-.06-.01-.09.03-.12.06,0,0-.04.03-.04.03-.03,0-.26-.09-.32-.2l.03.26-.44.42h-.35s-.46.45-.46.45l-.05.17.07.13c-.25.25-.26.25-.28.25-.03-.03-.05-.05-.06-.06,0-.01-.02-.05-.01-.06l.22-.2v-.07s-.04-.12-.04-.12c0,.01-.02.02-.03.04-.18.18-.24.23-.27.23-.05-.04-.83-.92-.83-.92l.04-.19-.5-.53s-.1-.03-.17-.03c-.18,0-.29.12-.33.34-.02.05-.08.07-.18.07-.13,0-.28-.03-.28-.03l-.2.05-1.17,1.66.66.76,1.31-1.7.03-.47.33.3s.05,0,.08,0c.06,0,.11,0,.16-.03l.83.89-.13.17.06.03.06.07.03-.05.07-.05s.05.03.06.04l.03.04c-.04.06-.07.08-.09.1-.03.02-.06.04-.09.06-.14-.07-.25-.17-.24-.32l-.41.4v.06s-1.34,1.12-1.34,1.12l-.13.02v.32s.82-.74.82-.74v-.08s.12.05.12.05l.64-.54c.08.07.08.08.07.09-.04.03-.38.34-.61.55v.05s-.12.1-.12.1l-.09-.04h0ZM191.75,10.37v.03s-.23.21-.23.21c.04.02.06.03.06.05,0-.04.11-.13.21-.22l-.04-.06h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Malawi"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 227.84,
    y: -0.58,
    width: 41.7,
    height: 12.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 227.84,
    y: 11.58,
    width: 41.7,
    height: 12.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 227.84,
    y: 7.53,
    width: 41.7,
    height: 8.11
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M248.7,3.43c-2.28,0-4.21,1.46-4.93,3.49h9.86c-.72-2.03-2.65-3.49-4.93-3.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M248.7.39c-.18,0-.24.26-.24.53,0,.64.08.97.24,1.91.17-.94.24-1.27.24-1.91,0-.26-.07-.53-.24-.53M247.98.42c-.18.02-.22.28-.2.55.05.63.16.96.41,1.88.08-.95.13-1.29.08-1.92-.02-.26-.11-.52-.29-.5M249.42.42c-.18-.02-.26.24-.29.5-.06.63,0,.97.08,1.92.25-.92.35-1.25.41-1.88.02-.26-.02-.53-.2-.55M247.29.51s-.02,0-.03,0c-.17.03-.19.3-.15.56.11.62.24.94.57,1.83,0-.95.02-1.29-.09-1.92-.04-.24-.14-.48-.3-.48M250.1.51c-.16,0-.26.24-.3.48-.11.63-.09.97-.09,1.92.32-.89.46-1.21.57-1.83.05-.26.03-.53-.15-.56-.01,0-.02,0-.03,0M246.59.67s-.02,0-.03,0c-.17.05-.17.32-.1.57.16.61.33.92.73,1.78-.08-.95-.09-1.29-.26-1.91-.06-.24-.19-.46-.34-.45M250.8.67c-.15-.01-.28.21-.34.45-.16.61-.17.96-.26,1.91.4-.86.57-1.17.73-1.78.07-.25.07-.53-.1-.57-.01,0-.02,0-.03,0M245.93.88s-.04,0-.06,0c-.16.06-.14.33-.05.58.22.6.4.88.88,1.71-.17-.94-.21-1.28-.42-1.88-.08-.22-.21-.41-.35-.42M251.46.88c-.14,0-.27.2-.35.42-.22.6-.26.94-.42,1.88.48-.83.66-1.11.88-1.71.09-.25.12-.52-.05-.58-.02,0-.04,0-.06,0M245.26,1.15s-.04,0-.06.02c-.16.07-.11.34,0,.58.27.58.48.84,1.03,1.62-.25-.92-.32-1.25-.59-1.83-.1-.21-.24-.4-.38-.39M252.13,1.15c-.14,0-.29.18-.38.39-.27.58-.34.91-.59,1.83.55-.78.76-1.05,1.03-1.62.11-.24.16-.51,0-.58-.02,0-.04-.01-.06-.02M244.62,1.48s-.04,0-.06.02c-.15.09-.08.35.05.58.32.55.55.8,1.16,1.53-.33-.89-.42-1.22-.74-1.77-.12-.2-.27-.37-.41-.36M252.74,1.48c-.13,0-.28.17-.39.36-.32.55-.42.88-.74,1.77.61-.73.85-.98,1.16-1.53.13-.23.2-.49.05-.58-.03-.02-.06-.02-.09-.02M244.04,1.86s-.06,0-.09.03c-.14.1-.05.36.1.57.36.52.62.75,1.29,1.42-.4-.86-.53-1.18-.89-1.7-.12-.17-.28-.33-.42-.32M253.35,1.86c-.13,0-.29.15-.42.32-.36.52-.49.84-.89,1.7.67-.67.93-.9,1.29-1.42.15-.22.25-.47.1-.57-.03-.02-.05-.03-.09-.03M243.46,2.29s-.06.02-.08.04c-.13.11-.02.36.15.56.41.49.68.69,1.41,1.3-.48-.83-.63-1.13-1.04-1.62-.14-.16-.31-.3-.44-.28M253.9,2.29c-.13,0-.28.13-.41.28-.41.49-.56.79-1.04,1.62.73-.61,1-.82,1.41-1.3.17-.2.29-.45.15-.56-.03-.03-.07-.04-.11-.04M242.96,2.76s-.08.02-.11.05c-.12.12.01.36.2.54.45.45.74.63,1.52,1.18-.55-.78-.73-1.07-1.18-1.52-.14-.14-.31-.25-.43-.25M254.43,2.76c-.13,0-.29.11-.43.25-.45.45-.63.74-1.18,1.52.78-.55,1.07-.73,1.52-1.18.19-.19.32-.42.2-.54-.03-.03-.07-.05-.11-.05M242.5,3.29c-.06,0-.1.02-.14.06-.11.13.04.35.25.52.49.41.79.56,1.62,1.04-.61-.73-.82-1-1.3-1.41-.14-.12-.3-.21-.42-.21M254.89,3.29c-.12,0-.28.09-.42.21-.49.41-.69.68-1.3,1.41.83-.48,1.13-.63,1.62-1.04.2-.17.36-.39.25-.52-.04-.04-.08-.06-.14-.06M242.05,3.85c-.06,0-.1.03-.14.07-.1.14.08.35.29.5.52.36.84.49,1.7.89-.67-.67-.9-.92-1.42-1.29-.15-.1-.32-.18-.44-.17M255.3,3.85c-.12,0-.27.08-.4.17-.52.36-.75.62-1.42,1.29.86-.4,1.18-.53,1.7-.89.22-.15.4-.36.3-.5-.04-.05-.1-.07-.17-.07M241.69,4.44c-.07,0-.13.03-.16.08-.09.15.11.34.34.47.55.32.88.42,1.77.74-.73-.61-.98-.85-1.53-1.16-.14-.08-.3-.14-.42-.14M255.7,4.44c-.12,0-.27.06-.41.14-.55.32-.8.55-1.53,1.16.9-.33,1.22-.42,1.77-.74.23-.13.42-.32.33-.47-.03-.06-.09-.08-.16-.08M241.43,5.07c-.11,0-.19.02-.23.1-.07.16.14.33.38.44.58.27.91.34,1.83.58-.78-.55-1.05-.76-1.62-1.03-.12-.06-.25-.1-.35-.1M255.96,5.07c-.11,0-.23.04-.35.1-.58.27-.84.48-1.63,1.03.92-.25,1.25-.32,1.83-.58.24-.11.45-.28.38-.44-.04-.08-.12-.11-.23-.1M241.14,5.71c-.11,0-.19.04-.22.12-.06.17.16.32.41.41.6.22.94.26,1.88.42-.83-.48-1.11-.66-1.71-.88-.12-.04-.25-.08-.36-.07M256.25,5.71c-.11,0-.24.03-.36.07-.6.22-.88.4-1.71.88.94-.16,1.28-.21,1.88-.42.25-.09.47-.24.41-.41-.03-.08-.11-.12-.22-.12M241,6.38c-.15,0-.26.04-.29.14-.05.17.19.3.45.37.04,0,.07.02.1.03h1.3c-.51-.24-.8-.37-1.28-.5-.1-.02-.19-.04-.28-.04M256.39,6.38c-.09,0-.19.02-.28.04-.48.13-.77.26-1.28.5h1.3s.07-.02.1-.03c.26-.07.49-.2.45-.37-.03-.11-.15-.15-.29-.14"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Botswana"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 269.55,
    y: -0.58,
    width: 41.85,
    height: 9.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 269.55,
    y: 8.45,
    width: 41.85,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 269.55,
    y: 14.8,
    width: 41.85,
    height: 9.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 269.55,
    y: 13.44,
    width: 41.85,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 269.55,
    y: 9.41,
    width: 41.85,
    height: 4.42
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_4",
    className: "cls-13",
    d: "M31.69,6.76c-12.21,0-24.42,0-36.64,0,0-2.44,0-4.87,0-7.31,12.21,0,24.42,0,36.64,0,0,2.44,0,4.87,0,7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3",
    className: "cls-45",
    d: "M-4.95,16.54c12.21,0,24.42,0,36.64,0,0,2.44,0,4.89,0,7.33-12.21,0-24.42,0-36.64,0,0-2.44,0-4.89,0-7.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_2",
    className: "cls-9",
    x: -4.95,
    y: 6.76,
    width: 36.64,
    height: 9.78
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1",
    className: "cls-12",
    d: "M11.76,9.21c.01-.76.29-1.41.84-1.7.14-.07.24-.06.4-.13.11-.05.19-.18.35-.18.17,0,.24.11.35.18.81.12,1.14.73,1.25,1.56.01.06-.02.17.02.2v.05s0,.14-.02.2c-.08.72-.3,1.3-.55,1.85.62.88,1.28,1.71,1.92,2.57.12-.03.21-.1.33-.13.24.46.45.94.7,1.39-.89.59-2.04.91-3.41,1.03-.06.01-.16-.02-.18.02h-.18c-.18,0-.37,0-.55,0-1.45-.06-2.58-.44-3.57-.97.2-.51.45-.96.66-1.45.11.05.23.08.35.13.66-.8,1.26-1.67,1.89-2.51-.25-.58-.49-1.18-.57-1.92-.01-.06.02-.16-.02-.18ZM13.7,7.78s0-.01,0-.02c-.15.24.02.91-.02,1.23.17.21.39.38.59.57-.12.1-.33-.07-.44.02-.12.1.04.83,0,.92.07.16.18.28.29.4.19-.45.37-.91.42-1.5.03-.1.03-.34,0-.44-.07-.6-.27-1.08-.84-1.17ZM13.04,8.32v-.53c-.55.12-.8.54-.86,1.15-.03.11-.03.35,0,.46.06.61.23,1.11.46,1.56.04-.17.26-.26.31-.46.06-.27-.05-.56,0-.88h-.46c.09-.12.22-.2.29-.33.07-.05.13-.11.18-.18.03-.02.07-.04.07-.09.03-.19.03-.51,0-.7ZM15.86,14.36c.07.15.2.24.27.38.14-.11.22-.28.31-.44-.09-.28-.39.02-.59.05ZM10.47,14.67c-.07-.1-.07-.27-.15-.37-.07.16-.16.29-.22.46.12-.03.27-.03.37-.09ZM10.71,14.33c.06.19.12.37.18.55.17-.04.34-.07.48-.15-.06-.29-.37-.34-.66-.4ZM14.96,14.64c.06.15.17.26.27.37.14-.17.66-.35.27-.51-.2.03-.35.12-.55.15ZM16.35,15.02c.15-.01.23-.09.37-.11-.04-.14-.12-.23-.16-.37-.1.12-.27.25-.2.48ZM11.68,14.6c.05.19.14.34.2.51.19-.03.31-.12.48-.16-.06-.28-.39-.29-.68-.35ZM13.92,14.78c.09.12.15.27.24.38.16-.1.35-.16.51-.26-.03-.34-.5-.18-.75-.13ZM12.93,14.77s-.18,0-.26-.02c0,.02,0,.05.02.05.08.14.15.31.26.42.2-.11.48-.15.66-.27-.04-.04-.06-.1-.07-.16h-.2s-.16,0-.24-.02h-.16ZM10.57,14.86c-.12-.03-.24.08-.38.09.1.12.3.13.44.2,0-.12-.05-.18-.05-.29ZM16.03,15.22c-.02-.12-.17-.28-.27-.38-.14.11-.3.2-.42.33.05.05.08.12.11.18.22-.02.37-.11.59-.13ZM11.41,14.93c-.13.05-.27.09-.4.13,0,.1.04.18.07.26.22.02.38.11.6.13-.09-.17-.14-.39-.27-.51ZM14.8,15.06c-.19.07-.35.17-.53.26.04.4.57.16.84.11-.11-.12-.21-.24-.31-.37ZM12.49,15.13c-.19.04-.33.12-.51.16.01.08.05.14.07.22.25.02.47.07.71.09-.07-.18-.2-.3-.27-.48ZM13.63,15.61h.38c-.07-.19-.2-.31-.29-.48-.23.07-.44.16-.66.24.02.11.09.17.13.26h.13c.1-.01.24.02.31-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    className: "cls-25",
    d: "M31.69-.62h30.64v24.51h-30.64V-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    className: "cls-31",
    d: "M31.69,5.25h30.64v12.77h-30.64V5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    className: "cls-16",
    d: "M31.69,6.53h30.64v10.21h-30.64V6.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8",
    className: "cls-1",
    d: "M56.86,9.3l-1.24.44,1.24.44,1.24-.44-1.24-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect10",
    className: "cls-8",
    d: "M38.12,9.59h17.92c.09,0,.16.07.16.15h0c0,.08-.07.15-.16.15h-17.92c-.09,0-.16-.07-.16-.15h0c0-.08.07-.15.16-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    className: "cls-8",
    d: "M55.76,9.88c.07,0,.15-.07.15-.15s-.07-.15-.15-.15M55.62,9.88c.07,0,.15-.07.15-.15s-.07-.15-.15-.15M55.47,9.88c.07,0,.15-.07.15-.15s-.07-.15-.15-.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "use15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.67,10.18l-1.24.44,1.24.44,1.24-.44-1.24-.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 36.77,
    y: 10.47,
    width: 18.24,
    height: 0.29,
    rx: 0.15,
    ry: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54.57,10.76c.07,0,.15-.07.15-.15s-.07-.15-.15-.15M54.43,10.76c.07,0,.15-.07.15-.15s-.07-.15-.15-.15M54.28,10.76c.07,0,.15-.07.15-.15s-.07-.15-.15-.15"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect17",
    className: "cls-6",
    d: "M34.96,11.42h24.37c.12,0,.22.1.22.22h0c0,.12-.1.22-.22.22h-24.37c-.12,0-.22-.1-.22-.22h0c0-.12.1-.22.22-.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    className: "cls-7",
    d: "M54.3,11.63c-1.46,1.46-3.4,4.38-7.3,4.38-3.4,0-5.84-2.92-7.3-4.38,1.46-1.46,3.89-4.38,7.3-4.38,3.89,0,5.84,2.92,7.3,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    className: "cls-11",
    d: "M46.5,8.78c.39.44.06.61.47.64.43.03.19.46.55.48.25.01-.03,1.03.22,1.36.25.35.46.1.46.36,0,.26-.68.24-.69,1.04-.02.46-.58.49-.6.79-.03.28,1.1.44,1.08.69-.02.25-1.22.21-1.27.5-.03.26,1.66.47,1.79,1.21-.25.08-.97.16-1.51.16-3.4,0-5.84-2.92-7.29-4.38,1.46-1.46,3.89-4.38,7.3-4.38,0,0-1.01.92-.51,1.52h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    className: "cls-10",
    d: "M42.61,11.25v-1.17M43.32,10.08v1.17M44.03,10.08v1.17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "use26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42.61,13.19v-1.17M43.32,12.02v1.17M44.03,12.02v1.17"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "use29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M44.73,11.25v-1.17M45.44,10.08v1.17M46.15,10.08v1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M44.73,13.19v-1.17M45.44,12.02v1.17M46.15,12.02v1.17"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "use34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.96,11.25v-1.17M48.67,10.08v1.17M49.38,10.08v1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.96,13.19v-1.17M48.67,12.02v1.17M49.38,12.02v1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.08,11.25v-1.17M50.79,10.08v1.17M51.5,10.08v1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.08,13.19v-1.17M50.79,12.02v1.17M51.5,12.02v1.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    className: "cls-3",
    d: "M57.8,11.46c-.22.38.17-.13,1.12.51.18.12.33.43.33.65-.04-.03-.08-.1-.13-.14-.07.07.07.39.09.54-.15-.08-.13-.12-.18-.23,0,.12-.03.47.03.6-.12-.03-.11-.13-.17-.15.04.15-.04.31-.02.48-.07-.07-.14-.12-.17-.15,0,.08-.13.29-.13.36-.06-.04-.07-.09-.08-.13-.07.09-.33.43-.35.53-.2-.18-.71-.6-.77-.83-.06.13-.14.17-.31.27-.07-.36-.31-.76-.18-1.07-.09.06-.17.11-.26.18.09-.52.54-1.13,1.19-1.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    className: "cls-41",
    d: "M56.98,13.36c.09-.18.18-.24.24-.36.1-.21.12-.37.21-.35.09.02.09.11-.03.31-.12.2-.17.25-.42.39ZM57.6,13.79c-.01-.14.03-.2.02-.29-.01-.16-.08-.27,0-.27.08,0,.12.05.12.21,0,.16-.02.2-.15.36h0ZM58.07,14.07c-.04-.19,0-.28-.03-.41-.04-.22-.12-.37-.04-.39s.13.05.15.28c.03.22.01.29-.08.52h0ZM58.56,12.7c-.12-.09-.18-.09-.26-.15-.13-.1-.2-.2-.24-.15-.04.05-.01.11.12.2.14.09.18.1.37.1h0ZM58.48,13.35c-.06-.13-.12-.16-.16-.24-.07-.14-.07-.27-.14-.23-.08.03-.08.1,0,.23.08.14.12.16.31.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    className: "cls-5",
    d: "M35.81,11.83c-.01-.11.01-.12-.06-.21.1.04.1.15.23.07.04-.02.06-.02,0-.15.13,0,.54.15.61.15.17,0,.49-.18.71.05.21.21.14.44.14.73-.09-.04-.04-.06-.13-.17.07.26,0,.73,0,1-.03-.07-.03-.04-.06-.11-.09.25-.2.3-.2.6-.03-.12,0-.09-.04-.15-.09.19-.68.35-.45.55-.2-.12-.29-.11-.39-.22-.04.03-.07.07-.11.14-.36-.17-.23-.52-.51-.76-.05.1-.03.09-.08.25-.06-.23-.07-.37-.14-.54-.06.09-.05.06-.15.2-.04-.28-.11-.34-.08-.52-.11.08-.04.04-.14.14.1-.71.54-1.23.85-1.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    className: "cls-41",
    d: "M35.37,12.98c.09-.23.18-.3.24-.45.11-.26.12-.46.21-.43.09.03.09.14-.03.39-.12.25-.17.31-.42.49h0ZM35.72,13.55c.04-.2.1-.28.12-.41.04-.23.02-.4.1-.39.08,0,.1.1.05.33-.06.23-.09.28-.27.48h0ZM36.14,13.95c.01-.2.06-.27.06-.4.01-.22-.03-.38.05-.39.08,0,.11.08.08.3-.02.22-.05.28-.19.48h0ZM37.04,12.66c-.17-.17-.28-.2-.39-.31-.2-.19-.29-.38-.36-.31-.07.06-.03.16.18.35.21.18.28.21.57.28ZM36.94,13.32c-.11-.17-.19-.22-.27-.33-.13-.2-.17-.36-.24-.32-.07.04-.06.13.08.32.14.19.19.22.43.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    className: "cls-4",
    d: "M44.65,8.03c-.2.39.35-.13,1.23.52.16.12.39.6.39.82-.19-.04-.51-.22-.51-.22,0,0,.39.39.39.83-.14-.09-.2-.07-.25-.18,0,.14.12.24.12.46-.08-.07-.17-.13-.26-.18.13.22-.23.65-.05.8-.32-.05-.64-.25-.77-.47-.07.05-.08.12-.08.19.01,0-.48-.37-.44-.51-.07.09-.08.14-.09.25-.18-.18-.35-.36-.41-.59-.08.1-.09.1-.17.21-.06-.37-.06-.35.06-.67-.09.06-.16.11-.24.18.08-.53.49-1.15,1.09-1.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "cls-41",
    d: "M44.15,9.94c.03-.27.1-.37.12-.54.04-.31,0-.53.1-.52.11,0,.14.12.09.42-.05.3-.1.38-.31.64h0ZM44.71,10.44c-.02-.23.02-.32,0-.47-.02-.26-.1-.43,0-.45.09-.02.14.07.15.33.01.26-.02.33-.15.59h0ZM45.59,10.84c-.1-.2-.18-.26-.24-.38-.11-.22-.13-.4-.22-.37-.08.03-.08.13.04.34.12.22.18.26.41.41ZM45.9,9.08c-.24-.13-.37-.13-.53-.21-.28-.14-.44-.31-.5-.22-.06.09.02.18.3.31.29.13.37.14.72.12h0ZM45.99,9.81c-.18-.15-.28-.17-.4-.26-.2-.17-.3-.33-.37-.26-.07.07-.02.15.19.31.21.16.28.18.58.22h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Malawi-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: -34.3,
    y: 23.85,
    width: 41.7,
    height: 12.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: -34.3,
    y: 36.01,
    width: 41.7,
    height: 12.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: -34.3,
    y: 31.96,
    width: 41.7,
    height: 8.11
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Botswana-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 7.4,
    y: 23.85,
    width: 41.85,
    height: 9.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 7.4,
    y: 32.88,
    width: 41.85,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 7.4,
    y: 39.23,
    width: 41.85,
    height: 9.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 7.4,
    y: 37.88,
    width: 41.85,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 7.4,
    y: 33.85,
    width: 41.85,
    height: 4.42
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MAURITIUS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 49.25,
    y: 23.85,
    width: 41.85,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 49.25,
    y: 29.95,
    width: 41.85,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 49.25,
    y: 36.06,
    width: 41.85,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 49.25,
    y: 42.16,
    width: 41.85,
    height: 6.1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_5",
    className: "cls-39",
    d: "M91.1,23.83h48.89s0,24.44,0,24.44h-48.89s0-24.44,0-24.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_4-2",
    className: "cls-24",
    d: "M91.1,23.83h32.59s-32.59,24.44-32.59,24.44v-24.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3-2",
    className: "cls-9",
    d: "M139.99,31.98v16.3s-48.89,0-48.89,0l48.89-16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2-2",
    className: "cls-20",
    d: "M91.1,23.83h16.3s-16.3,24.44-16.3,24.44v-24.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1-2",
    className: "cls-27",
    d: "M91.1,48.28h48.89s0-8.15,0-8.15l-48.89,8.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_4-3",
    className: "cls-13",
    d: "M176.62,31.14c-12.21,0-24.42,0-36.64,0,0-2.44,0-4.87,0-7.31,12.21,0,24.42,0,36.64,0v7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3-3",
    className: "cls-45",
    d: "M139.99,40.93c12.21,0,24.42,0,36.64,0,0,2.44,0,4.89,0,7.33-12.21,0-24.42,0-36.64,0,0-2.44,0-4.89,0-7.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_2-3",
    className: "cls-9",
    x: 139.99,
    y: 31.14,
    width: 36.64,
    height: 9.78
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1-3",
    className: "cls-12",
    d: "M156.69,33.6c.01-.76.29-1.41.84-1.7.14-.07.24-.06.4-.13.11-.05.19-.18.35-.18.17,0,.24.11.35.18.81.12,1.14.73,1.25,1.56.01.06-.02.17.02.2v.05s0,.14-.02.2c-.08.72-.3,1.3-.55,1.85.62.88,1.28,1.71,1.92,2.57.12-.03.21-.1.33-.13.24.46.45.94.7,1.39-.89.59-2.04.91-3.41,1.03-.06.01-.16-.02-.18.02h-.18c-.18,0-.37,0-.55,0-1.45-.06-2.58-.44-3.57-.97.2-.51.45-.96.66-1.45.11.05.23.08.35.13.66-.8,1.26-1.67,1.89-2.51-.25-.58-.49-1.18-.57-1.92-.01-.06.02-.16-.02-.18ZM158.64,32.17s0-.01,0-.02c-.15.24.02.91-.02,1.23.17.21.39.38.59.57-.12.1-.33-.07-.44.02-.12.1.04.83,0,.92.07.16.18.28.29.4.19-.45.37-.91.42-1.5.03-.1.03-.34,0-.44-.07-.6-.27-1.08-.84-1.17ZM157.98,32.7v-.53c-.55.12-.8.54-.86,1.15-.03.11-.03.35,0,.46.06.61.23,1.11.46,1.56.04-.17.26-.26.31-.46.06-.27-.05-.56,0-.88h-.46c.09-.12.22-.2.29-.33.07-.05.13-.11.18-.18.03-.02.07-.04.07-.09.03-.19.03-.51,0-.7ZM160.8,38.75c.07.15.2.24.27.38.14-.11.22-.28.31-.44-.09-.28-.39.02-.59.05ZM155.41,39.06c-.07-.1-.07-.27-.15-.37-.07.16-.16.29-.22.46.12-.03.27-.03.37-.09ZM155.65,38.71c.06.19.12.37.18.55.17-.04.34-.07.48-.15-.06-.29-.37-.34-.66-.4ZM159.9,39.02c.06.15.17.26.27.37.14-.17.66-.35.27-.51-.2.03-.35.12-.55.15ZM161.29,39.41c.15-.01.23-.09.37-.11-.04-.14-.12-.23-.16-.37-.1.12-.27.25-.2.48ZM156.62,38.99c.05.19.14.34.2.51.19-.03.31-.12.48-.16-.06-.28-.39-.29-.68-.35ZM158.86,39.17c.09.12.15.27.24.38.16-.1.35-.16.51-.26-.03-.34-.5-.18-.75-.13ZM157.87,39.15s-.18,0-.26-.02c0,.02,0,.05.02.05.08.14.15.31.26.42.2-.11.48-.15.66-.27-.04-.04-.06-.1-.07-.16h-.2s-.16,0-.24-.02h-.16ZM155.5,39.24c-.12-.03-.24.08-.38.09.1.12.3.13.44.2,0-.12-.05-.18-.05-.29ZM160.96,39.61c-.02-.12-.17-.28-.27-.38-.14.11-.3.2-.42.33.05.05.08.12.11.18.22-.02.37-.11.59-.13ZM156.35,39.32c-.13.05-.27.09-.4.13,0,.1.04.18.07.26.22.02.38.11.6.13-.09-.17-.14-.39-.27-.51ZM159.74,39.45c-.19.07-.35.17-.53.26.04.4.57.16.84.11-.11-.12-.21-.24-.31-.37ZM157.43,39.52c-.19.04-.33.12-.51.16.01.08.05.14.07.22.25.02.47.07.71.09-.07-.18-.2-.3-.27-.48ZM158.56,39.99h.38c-.07-.19-.2-.31-.29-.48-.23.07-.44.16-.66.24.02.11.09.17.13.26h.13c.1-.01.24.02.31-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2-2",
    className: "cls-25",
    d: "M176.62,23.76h30.64v24.51h-30.64v-24.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4-2",
    className: "cls-31",
    d: "M176.62,29.64h30.64v12.77h-30.64v-12.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6-2",
    className: "cls-16",
    d: "M176.62,30.91h30.64v10.21h-30.64v-10.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g19-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8-2",
    className: "cls-1",
    d: "M201.79,33.69l-1.24.44,1.24.44,1.24-.44-1.24-.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect10-2",
    className: "cls-8",
    x: 182.9,
    y: 33.98,
    width: 18.24,
    height: 0.29,
    rx: 0.15,
    ry: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12-2",
    className: "cls-8",
    d: "M200.7,34.27c.07,0,.15-.07.15-.15s-.07-.15-.15-.15M200.55,34.27c.07,0,.15-.07.15-.15s-.07-.15-.15-.15M200.41,34.27c.07,0,.15-.07.15-.15s-.07-.15-.15-.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "use15-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.6,34.56l-1.24.44,1.24.44,1.24-.44-1.24-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M181.87,34.85h17.92c.09,0,.16.07.16.15h0c0,.08-.07.15-.16.15h-17.92c-.09,0-.16-.07-.16-.15h0c0-.08.07-.15.16-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M199.51,35.15c.07,0,.15-.07.15-.15s-.07-.15-.15-.15M199.37,35.15c.07,0,.15-.07.15-.15s-.07-.15-.15-.15M199.22,35.15c.07,0,.15-.07.15-.15s-.07-.15-.15-.15"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect17-2",
    className: "cls-6",
    d: "M179.89,35.8h24.37c.12,0,.22.1.22.22h0c0,.12-.1.22-.22.22h-24.37c-.12,0-.22-.1-.22-.22h0c0-.12.1-.22.22-.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path21-2",
    className: "cls-7",
    d: "M199.24,36.02c-1.46,1.46-3.4,4.38-7.3,4.38-3.4,0-5.84-2.92-7.3-4.38,1.46-1.46,3.89-4.38,7.3-4.38,3.89,0,5.84,2.92,7.3,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23-2",
    className: "cls-11",
    d: "M191.43,33.17c.39.44.06.61.47.64.43.03.19.46.55.48.25.01-.03,1.03.22,1.36.25.35.46.1.46.36,0,.26-.68.24-.69,1.04-.02.46-.58.49-.6.79-.03.28,1.1.44,1.08.69-.02.25-1.22.21-1.27.5-.03.26,1.66.47,1.79,1.21-.25.08-.97.16-1.51.16-3.4,0-5.84-2.92-7.29-4.38,1.46-1.46,3.89-4.38,7.3-4.38,0,0-1.01.92-.51,1.52h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g32-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b-2",
    className: "cls-10",
    d: "M187.55,35.63v-1.17M188.26,34.47v1.17M188.96,34.47v1.17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "use26-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M187.55,37.58v-1.17M188.26,36.41v1.17M188.96,36.41v1.17"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "use29-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M189.67,35.63v-1.17M190.38,34.47v1.17M191.09,34.47v1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M189.67,37.58v-1.17M190.38,36.41v1.17M191.09,36.41v1.17"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "use34-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.9,35.63v-1.17M193.61,34.47v1.17M194.31,34.47v1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.9,37.58v-1.17M193.61,36.41v1.17M194.31,36.41v1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.02,35.63v-1.17M195.73,34.47v1.17M196.44,34.47v1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.02,37.58v-1.17M195.73,36.41v1.17M196.44,36.41v1.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36-2",
    className: "cls-3",
    d: "M202.74,35.85c-.22.38.17-.13,1.12.51.18.12.33.43.33.65-.04-.03-.08-.1-.13-.14-.07.07.07.39.09.54-.15-.08-.13-.12-.18-.23,0,.12-.03.47.03.6-.12-.03-.11-.13-.17-.15.04.15-.04.31-.02.48-.07-.07-.14-.12-.17-.15,0,.08-.13.29-.13.36-.06-.04-.07-.09-.08-.13-.07.09-.33.43-.35.53-.2-.18-.71-.6-.77-.83-.06.13-.14.17-.31.27-.07-.36-.31-.76-.18-1.07-.09.06-.17.11-.26.18.09-.52.54-1.13,1.19-1.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38-2",
    className: "cls-41",
    d: "M201.91,37.74c.09-.18.18-.24.24-.36.1-.21.12-.37.21-.35.09.02.09.11-.03.31-.12.2-.17.25-.42.39ZM202.53,38.18c-.01-.14.03-.2.02-.29-.01-.16-.08-.27,0-.27.08,0,.12.05.12.21,0,.16-.02.2-.15.36h0ZM203,38.45c-.04-.19,0-.28-.03-.41-.04-.22-.12-.37-.04-.39s.13.05.15.28c.03.22.01.29-.08.52h0ZM203.49,37.09c-.12-.09-.18-.09-.26-.15-.13-.1-.2-.2-.24-.15-.04.05-.01.11.12.2.14.09.18.1.37.1h0ZM203.41,37.74c-.06-.13-.12-.16-.16-.24-.07-.14-.07-.27-.14-.23-.08.03-.08.1,0,.23.08.14.12.16.31.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40-2",
    className: "cls-5",
    d: "M180.75,36.22c-.01-.11.01-.12-.06-.21.1.04.1.15.23.07.04-.02.06-.02,0-.15.13,0,.54.15.61.15.17,0,.49-.18.71.05.21.21.14.44.14.73-.09-.04-.04-.06-.13-.17.07.26,0,.73,0,1-.03-.07-.03-.04-.06-.11-.09.25-.2.3-.2.6-.03-.12,0-.09-.04-.15-.09.19-.68.35-.45.55-.2-.12-.29-.11-.39-.22-.04.03-.07.07-.11.14-.36-.17-.23-.52-.51-.76-.05.1-.03.09-.08.25-.06-.23-.07-.37-.14-.54-.06.09-.05.06-.15.2-.04-.28-.11-.34-.08-.52-.11.08-.04.04-.14.14.1-.71.54-1.23.85-1.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42-2",
    className: "cls-41",
    d: "M180.31,37.37c.09-.23.18-.3.24-.45.11-.26.12-.46.21-.43.09.03.09.14-.03.39-.12.25-.17.31-.42.49h0ZM180.66,37.94c.04-.2.1-.28.12-.41.04-.23.02-.4.1-.39.08,0,.1.1.05.33-.06.23-.09.28-.27.48h0ZM181.08,38.34c.01-.2.06-.27.06-.4.01-.22-.03-.38.05-.39.08,0,.11.08.08.3-.02.22-.05.28-.19.48h0ZM181.98,37.04c-.17-.17-.28-.2-.39-.31-.2-.19-.29-.38-.36-.31-.07.06-.03.16.18.35.21.18.28.21.57.28ZM181.88,37.71c-.11-.17-.19-.22-.27-.33-.13-.2-.17-.36-.24-.32-.07.04-.06.13.08.32.14.19.19.22.43.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44-2",
    className: "cls-4",
    d: "M189.59,32.42c-.2.39.35-.13,1.23.52.16.12.39.6.39.82-.19-.04-.51-.22-.51-.22,0,0,.39.39.39.83-.14-.09-.2-.07-.25-.18,0,.14.12.24.12.46-.08-.07-.17-.13-.26-.18.13.22-.23.65-.05.8-.32-.05-.64-.25-.77-.47-.07.05-.08.12-.08.19.01,0-.48-.37-.44-.51-.07.09-.08.14-.09.25-.18-.18-.35-.36-.41-.59-.08.1-.09.1-.17.21-.06-.37-.06-.35.06-.67-.09.06-.16.11-.24.18.08-.53.49-1.15,1.09-1.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46-2",
    className: "cls-41",
    d: "M189.09,34.33c.03-.27.1-.37.12-.54.04-.31,0-.53.1-.52.11,0,.14.12.09.42-.05.3-.1.38-.31.64h0ZM189.65,34.82c-.02-.23.02-.32,0-.47-.02-.26-.1-.43,0-.45.09-.02.14.07.15.33.01.26-.02.33-.15.59h0ZM190.53,35.23c-.1-.2-.18-.26-.24-.38-.11-.22-.13-.4-.22-.37-.08.03-.08.13.04.34.12.22.18.26.41.41ZM190.84,33.47c-.24-.13-.37-.13-.53-.21-.28-.14-.44-.31-.5-.22-.06.09.02.18.3.31.29.13.37.14.72.12h0ZM190.93,34.2c-.18-.15-.28-.17-.4-.26-.2-.17-.3-.33-.37-.26-.07.07-.02.15.19.31.21.16.28.18.58.22h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 207.26,
    y: 23.88,
    width: 40.21,
    height: 24.34
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "207.26 26.53 207.26 45.71 221.62 36.1 207.26 26.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "247.48 33.71 226.63 33.71 211.77 23.88 207.26 23.88 207.26 26.8 221.1 36.11 207.26 45.39 207.26 48.22 211.99 48.22 226.32 38.54 247.48 38.54 247.48 33.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "247.48 23.88 214.73 23.88 226.87 31.91 247.48 31.91 247.48 23.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "247.48 40.24 226.87 40.24 214.79 48.22 247.48 48.22 247.48 40.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "207.26 28.83 207.26 43.4 218.17 36.11 207.26 28.83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NAMIBIA-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "247.48 23.82 247.48 48.23 289.32 23.82 247.48 23.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "289.32 23.82 247.48 48.23 289.32 48.23 289.32 23.82"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "249.67 51.98 245.28 44.47 287.13 20.07 291.52 27.58 249.67 51.98 249.67 51.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "249.12 51.04 245.83 45.41 287.68 21.01 290.97 26.64 249.12 51.04 249.12 51.04"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "259.83 32.57 258.03 32.26 258.34 34.06 256.94 32.89 256.31 34.6 255.68 32.89 254.27 34.06 254.58 32.26 252.78 32.57 253.95 31.17 252.24 30.53 253.95 29.9 252.78 28.5 254.58 28.81 254.27 27.01 255.68 28.18 256.31 26.47 256.94 28.18 258.34 27.01 258.03 28.81 259.83 28.5 258.67 29.9 260.38 30.53 258.67 31.17 259.83 32.57"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M258.75,30.53c0,1.35-1.09,2.44-2.44,2.44-1.35,0-2.44-1.09-2.44-2.44s1.09-2.44,2.44-2.44c1.35,0,2.44,1.09,2.44,2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M258.34,30.53c0,1.12-.91,2.03-2.03,2.03-1.12,0-2.03-.91-2.03-2.03,0-1.12.91-2.03,2.03-2.03s2.03.91,2.03,2.03"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 0,
    y: 0,
    width: 284.84,
    height: 46.86,
    rx: 23.43,
    ry: 23.43
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: -0.33,
    y: -0.5,
    width: 40.21,
    height: 24.34
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "-.33 2.14 -.33 21.32 14.03 11.72 -.33 2.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "39.89 9.32 19.04 9.32 4.18 -.5 -.33 -.5 -.33 2.41 13.51 11.72 -.33 21.01 -.33 23.84 4.4 23.84 18.73 14.16 39.89 14.16 39.89 9.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "39.89 -.5 7.14 -.5 19.28 7.52 39.89 7.52 39.89 -.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "39.89 15.85 19.28 15.85 7.2 23.84 39.89 23.84 39.89 15.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "-.33 4.44 -.33 19.02 10.58 11.72 -.33 4.44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NAMIBIA-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "39.89 -.56 39.89 23.84 81.73 -.56 39.89 -.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "81.73 -.56 39.89 23.84 81.73 23.84 81.73 -.56"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "42.08 27.6 37.69 20.08 79.54 -4.32 83.92 3.19 42.08 27.6 42.08 27.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "41.53 26.66 38.24 21.02 80.09 -3.38 83.38 2.25 41.53 26.66 41.53 26.66"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "52.24 8.18 50.44 7.87 50.75 9.67 49.35 8.5 48.72 10.21 48.09 8.5 46.68 9.67 46.99 7.87 45.19 8.18 46.36 6.78 44.65 6.15 46.36 5.52 45.19 4.11 46.99 4.42 46.68 2.63 48.09 3.79 48.72 2.08 49.35 3.79 50.75 2.63 50.44 4.42 52.24 4.11 51.08 5.52 52.79 6.15 51.08 6.78 52.24 8.18"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M51.16,6.15c0,1.35-1.09,2.44-2.44,2.44s-2.44-1.09-2.44-2.44c0-1.35,1.09-2.44,2.44-2.44,1.35,0,2.44,1.09,2.44,2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M50.75,6.15c0,1.12-.91,2.03-2.03,2.03-1.12,0-2.03-.91-2.03-2.03s.91-2.03,2.03-2.03,2.03.91,2.03,2.03"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ZIMBABWE-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 81.55,
    y: -0.54,
    width: 41.85,
    height: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 81.55,
    y: 2.95,
    width: 41.85,
    height: 17.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 81.55,
    y: 6.44,
    width: 41.85,
    height: 10.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 81.55,
    y: 9.92,
    width: 41.85,
    height: 3.49
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "81.55 -.54 81.55 23.87 82.43 23.87 98.7 11.67 82.43 -.54 81.55 -.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "81.55 -.54 81.55 23.87 97.81 11.67 81.55 -.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "88.13 5.47 85.39 11.03 89.55 13.08 88.13 5.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "88.13 5.47 90.87 11.03 86.7 13.08 88.13 5.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "88.13 5.47 86.05 11.31 90.43 12.86 88.13 5.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "88.13 5.47 90.21 11.31 85.83 12.86 88.13 5.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "94.02 9.75 87.89 8.86 87.22 13.46 94.02 9.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "82.24 9.75 88.37 8.86 89.04 13.46 82.24 9.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "94.02 9.75 87.83 9.58 87.7 14.23 94.02 9.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "82.24 9.75 88.43 9.58 88.56 14.23 82.24 9.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "91.26 15.97 90.17 10.76 87.57 11.3 91.26 15.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "91.26 15.97 86.64 13.33 87.96 11.02 91.26 15.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "85 15.97 89.62 13.33 88.3 11.02 85 15.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "85 15.97 86.09 10.76 88.69 11.3 85 15.97"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M90.26,15.54c0-.78.14-1.53.42-2.33.13-.36.47-1.1.56-1.21,0-.01.15.02.32.06.34.1.44.08.44-.08,0-.09-.35-.4-2.06-1.83-1.15-.96-2.1-1.72-2.14-1.72s-.09-.03-.1-.06c-.01-.03-.07-.4-.12-.83-.06-.43-.14-.84-.17-.93-.11-.26-.33-.39-.69-.41-.27-.02-.33,0-.51.1-.12.07-.27.12-.37.12-.2,0-.37.16-.37.35v.13s.3,0,.3,0c.16,0,.25,0,.18.01-.21.04-.13.34.12.43.27.1.26.04.26,1.3,0,1.03,0,1.18-.08,1.42-.11.35-.11.87,0,1.21.04.14.08.27.08.29,0,.02-.13.19-.28.38-.28.34-.46.7-.46.96,0,.06-.04.16-.08.22-.1.15-.11.4,0,.5.11.1.54,1.89.54,2.23,0,.12.02.12.68-.02.53-.11,1.79-.14,2.43-.05.29.04.64.11.76.14.39.11.37.13.37-.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.72,15.79c-.58-.14-1.24-.19-1.98-.16-.37.02-.77.05-.87.07l-.19.04-.05-.32c-.03-.17-.04-.32-.03-.33,0,0,.19-.04.4-.07.74-.11,2.31-.07,3.04.08l.13.03v.38c0,.28-.01.38-.05.38-.03,0-.21-.04-.4-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M86.1,15.82c0-.09-.23-1.19-.33-1.58-.07-.26-.12-.5-.12-.52,0-.02.06,0,.14.06.08.05.17.1.22.1.21,0,.33.32.51,1.4.03.15.05.32.07.37.02.09,0,.11-.19.15-.23.06-.29.06-.29.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M90.11,14.98s0-.07.04-.1c.05-.05.06-.04.06.02,0,.08-.07.14-.1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M86.81,14.81c.11-.12.11-.12.2-.04.08.08.08.09.01.12-.04.02-.13.03-.2.04h-.12s.11-.12.11-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.52,14.88s.05-.08.1-.11c.07-.05.09-.04.15.05l.07.11h-.17c-.11,0-.16-.02-.15-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.89,14.81c-.05-.07-.08-.13-.07-.14,0,0,.09,0,.19.02l.18.03-.1.11-.1.11-.09-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M86.52,14.82c-.03-.09.04-.16.16-.16.09,0,.09,0-.03.13-.09.1-.1.1-.13.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M87.49,14.74l.11-.13.11.1c.06.06.11.11.12.11,0,0-.09.02-.21.02l-.23.02.11-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M88.94,14.84l-.14-.03.1-.1.1-.1.12.14c.13.15.12.16-.18.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M87.13,14.72l-.1-.12h.15c.08,0,.18-.01.22-.03.06-.03.05,0-.03.12-.05.08-.11.14-.12.14s-.07-.05-.12-.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M88.18,14.7l.12-.14.12.12c.06.07.12.13.12.14s-.11.01-.23.01h-.23s.12-.14.12-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.27,14.72l-.1-.12h.19c.21,0,.23.03.12.15-.1.1-.1.1-.21-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M87.83,14.68l-.1-.11h.22s.22,0,.22,0l-.1.11c-.12.14-.13.14-.25,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M88.57,14.68l-.1-.11h.22s.22,0,.22,0l-.1.11c-.12.14-.13.14-.25,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.88,14.56c-.1-.02-.51-.06-.91-.09-.69-.06-1.55-.03-2.31.08-.16.02-.2.01-.2-.04,0-.12.83-.2,2.1-.2.62,0,1.26.02,1.41.04.26.03.28.05.28.15,0,.12-.03.13-.37.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M86.68,14.17c.08-.09.17-.16.19-.16s.08.05.13.11l.09.11-.2.03c-.11.02-.24.04-.28.05-.06.01-.04-.02.07-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M86.39,14.19c-.03-.09-.02-.12.05-.15.05-.02.12-.03.16-.02.07.01.06.03-.05.15l-.13.13-.04-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M90.21,14.25s.03-.05.06-.07c.04-.02.05,0,.04.04-.03.07-.1.09-.1.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M87.45,14.08c.06-.08.11-.14.11-.15,0,0,.06.05.13.12l.13.13-.24.02-.24.02.11-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.65,14.21l-.18-.02.13-.12.13-.12.1.11c.11.12.13.19.05.17-.03,0-.13-.02-.23-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M87.1,14.08l-.12-.11.2-.03c.11-.02.2-.03.21-.02,0,0-.03.07-.08.14l-.09.12-.12-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M88.9,14.16l-.1-.03.1-.11c.09-.09.11-.1.17-.05.04.03.08.1.11.14.03.07.02.08-.07.08-.06,0-.16-.02-.21-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.94,14.05l-.12-.14.1.03c.06.02.18.03.27.03h.16s-.12.11-.12.11c-.07.06-.13.11-.15.12-.01,0-.08-.06-.14-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M87.83,14.04c-.05-.06-.09-.12-.09-.14,0-.02.1-.03.23-.03h.23s-.08.1-.08.1c-.14.17-.2.18-.3.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M88.21,14.03c.13-.13.18-.13.26.02.06.1.06.1-.16.1h-.22s.12-.12.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.23,14.01l-.1-.14h.1c.06,0,.16.01.23.03l.13.03-.12.11c-.06.06-.12.11-.13.11,0,0-.06-.06-.11-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M88.57,13.99l-.1-.12h.22s.22,0,.22,0l-.1.12c-.12.14-.13.14-.25,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M86.37,13.84s.05-.18.08-.31l.05-.23.45-.25c.25-.14.53-.31.62-.39.09-.08.18-.16.21-.17.06-.04,1.26.05,1.79.13.41.07,1.12.21,1.14.23,0,0-.06.21-.14.46-.08.25-.16.48-.17.52-.01.05-.06.05-.2.03-.68-.11-2.63-.1-3.38.02-.43.07-.49.06-.45-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M89.81,13.56c.27-.3.08-.78-.29-.78-.24,0-.41.19-.41.46,0,.42.44.62.7.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.36,13.55c-.22-.12-.21-.53.02-.63.23-.1.46.06.46.32,0,.25-.27.43-.48.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M88.15,13.53c.25-.23.19-.64-.1-.78-.19-.09-.4-.02-.51.18-.12.22-.1.38.06.56.18.2.37.21.56.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M87.76,13.51c-.3-.14-.2-.69.13-.69.32,0,.43.5.14.67-.13.08-.15.08-.27.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M86.18,13.71c.06-.17.05-.39-.01-.39-.03,0-.05.06-.05.16,0,.09-.02.19-.05.22-.05.05-.05.01-.03-.21.01-.15,0-.26-.01-.26-.04,0-.11.22-.13.41q-.02.11-.05-.02c-.03-.1-.01-.17.05-.31.05-.09.09-.23.09-.31,0-.11.08-.22.46-.63.25-.27.55-.61.65-.75.18-.24.19-.27.19-.52,0-.14-.02-.27-.03-.29-.05-.05-.11.22-.09.37.02.14,0,.18-.27.52-.16.2-.43.51-.6.68-.32.32-.43.49-.43.65,0,.05-.04.18-.08.29-.04.11-.07.22-.06.25.01.03,0,.03-.03,0-.04-.04-.04-.1,0-.25.02-.11.03-.22.02-.24-.04-.08-.1.02-.12.24-.02.12-.04.21-.06.2-.06-.04-.04-.27.03-.38.04-.06.08-.2.1-.32.05-.32.18-.58.47-.92.14-.18.26-.33.26-.33,0,0-.04-.14-.09-.29-.11-.34-.12-.87-.02-1.19.1-.33.32-.67.65-1.02.35-.36.68-.58.84-.55.14.02,4.13,3.36,4.13,3.45,0,.04-.03.07-.07.06-.04,0-1.05-.31-2.25-.68-1.92-.6-2.19-.69-2.28-.8-.12-.15-.12-.38-.01-.54.05-.06.08-.14.08-.18,0-.1-.2.16-.24.31-.05.18.04.47.16.57.05.04.41.17.81.3.68.21.72.24.76.36.09.29-.2.62-.61.72-.13.03-.3.12-.42.21-.46.37-.79.59-1.06.72-.16.07-.31.16-.34.19-.03.03-.07.16-.09.3-.05.28-.07.33-.15.33-.05,0-.05-.03-.02-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M90.36,12.66c-.42-.1-1.09-.2-1.77-.26l-.65-.06.25-.1c.14-.05.33-.15.43-.21.16-.1.23-.11.47-.09.37.03.62-.04.71-.21.04-.07.08-.13.08-.14,0,0,.3.07.65.18l.64.2-.12.23c-.07.13-.15.3-.19.38-.08.17-.1.17-.48.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M88.91,11.82s-.03-.05,0-.11c.03-.05.06-.07.08-.03.04.07-.03.19-.09.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.06,11.81c0-.06.03-.06.06,0,.01.03,0,.05-.02.05s-.04-.02-.04-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.27,11.79s.02-.06.04-.04c.05.04.05.11,0,.11-.02,0-.04-.03-.04-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.46,11.79s-.03-.06-.03-.1c0-.05.01-.06.05-.02.02.03.04.07.03.1,0,.03-.03.04-.05.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.13,11.7s-.03-.07-.03-.1c0-.05.01-.06.05-.02.03.03.04.08.03.1,0,.03-.03.04-.05.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.62,11.67c-.04-.08,0-.1.06-.02.03.04.04.07,0,.07-.02,0-.06-.02-.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.29,11.59s0-.05.02-.07c.02-.02.04,0,.04.04,0,.08-.02.09-.06.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.47,11.51s.02-.06.04-.04c.05.04.05.11,0,.11-.02,0-.04-.03-.04-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M88.98,11.47c0-.08.02-.09.06-.03.01.02,0,.05-.02.07-.02.02-.04,0-.04-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M89.14,11.42s.02-.06.04-.04c.05.04.05.12,0,.12-.02,0-.04-.03-.04-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M86.37,9.22c-.01-.2-.01-.66,0-1.03.02-.76,0-.83-.23-.92-.19-.07-.26-.12-.26-.21,0-.06.04-.07.25-.04.22.03.25.02.24-.05-.02-.12-.31-.21-.61-.19-.24.01-.27,0-.25-.06.03-.14.17-.23.37-.25.11-.01.27-.06.35-.11.13-.08.22-.09.46-.08.54.03.64.19.78,1.22.05.4.1.77.1.82,0,.07-.07.15-.26.29-.28.2-.64.56-.81.82l-.1.15-.02-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M86.78,6.82c.06-.08.07-.11.03-.21-.06-.14-.13-.11-.1.05.02.09,0,.12-.07.12s-.09-.03-.09-.14,0-.13-.06-.08c-.08.07-.08.18,0,.28.09.11.19.11.28,0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "MOZAMBIQUE-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 123.39,
    y: -0.54,
    width: 41.85,
    height: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 123.39,
    y: -0.54,
    width: 41.85,
    height: 8.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 123.39,
    y: -0.54,
    width: 41.85,
    height: 7.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 123.39,
    y: 15.47,
    width: 41.85,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 123.39,
    y: 16.24,
    width: 41.85,
    height: 7.63
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "123.39 -.54 123.39 23.87 139.41 11.67 123.39 -.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "131.71 16.24 128.73 14.06 125.76 16.24 126.91 12.74 123.92 10.59 127.61 10.6 128.73 7.09 129.86 10.6 133.55 10.58 130.55 12.74 131.71 16.24"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M126.15,13.8h2.14c.17.19.56.27.92,0,.67-.37,1.97,0,1.97,0l.26-.27-.62-2.05-.22-.24s-.48-.29-1.39-.19c-.91.1-1.23-.03-1.23-.03,0,0-.8.09-1.02.21-.02.02-.26.26-.26.26l-.54,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M128.72,14h0c-.18,0-.35-.07-.45-.18h-2.12s.52-2.34.52-2.34c0-.01.24-.25.27-.27.23-.12,1-.21,1.04-.21.02,0,.34.12,1.23.03.91-.1,1.39.19,1.41.2l.23.24.63,2.06-.26.3s-.61-.16-1.18-.16c-.33,0-.6.05-.79.16-.16.12-.33.18-.51.18h0ZM128.29,13.77c.11.11.27.18.43.18h0c.16,0,.33-.06.48-.17.2-.11.48-.17.82-.17.58,0,1.17.17,1.17.17l.23-.26-.63-2.02-.22-.23h0s-.49-.28-1.37-.19c-.91.1-1.24-.03-1.24-.03,0,0-.79.1-1,.21-.02.02-.25.25-.25.25l-.54,2.31,2.12-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M128.71,14c-.15,0-.3-.06-.45-.16.04-.08.19-.24.47-.38-.81-.32-2.13-.16-2.15-.16-.02,0-.03,0-.03-.02,0-.01,0-.03.02-.03.07,0,1.38-.17,2.2.19.4-.19,1.05-.34,1.99-.21.01,0,.02.02.02.03,0,.02-.01.03-.03.02-.92-.13-1.54.01-1.92.18.17.08.31.18.41.32-.19.15-.36.22-.53.22h0ZM128.79,13.48c-.35.16-.49.34-.49.35.29.18.57.18.91-.05-.1-.12-.24-.22-.41-.3h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "128.78 13.48 128.75 11.22 128.79 11.22 128.78 13.48 128.78 13.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "131 13.04 130.58 11.26 130.62 11.25 131 13.04 131 13.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M126.76,12.18s0,0,0,0c-.01,0-.02-.02-.02-.03l.21-.92s.02-.02.03-.02c.01,0,.02.02.02.03l-.21.92s-.01.02-.02.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M124.76,14.04l.5.59c.06.03.11.03.17,0l.75-.9.31-.39c.05-.06.06-.12.06-.18l.6-.53s.08,0,.13.01c-.06-.01-.1-.04-.06-.11l.13-.1.1.13s-.15.19-.16.19h-.16s-.31.28-.31.28l.14.12.21.57.25-.18-.16-.58.36-.39-.13-.21.09-.12s1.24.78,1.72.57c.01,0,.03-.56.03-.56,0,0-1.29-.13-1.31-.39-.03-.25.28-.28.28-.28l-.13-.19.03-.1.22.28.51-.43,2.99,3.41c.16-.07.2-.11.21-.27,0,0-2.93-3.36-2.93-3.36l.22-.24s.06-.07.06-.15l.34-.3c.1.04.17.1.22.18l.95-.8s.1.05.15.02l1.56-1.5-1.7,1.2-.06-.04s.06-.06,0-.15c-.07-.08-.16.07-.18.07s-.25-.08-.3-.19l-.02.27-.43.4-.33-.02-.48.46-.06.18.07.15s-.25.22-.25.21-.05-.07-.05-.07l.22-.2.03-.13-.07-.11s-.3.31-.32.28c-.02-.03-.81-.91-.81-.91l.05-.16-.51-.55c-.19-.06-.48-.07-.54.33-.05.09-.43.02-.43.02l-.21.05-1.18,1.67.66.79,1.34-1.7.04-.48.28.31c.09.01.18.01.27-.03l.8.89-.13.13s.08.08.12.13c.04-.03.09-.07.13-.1.02.02.04.06.05.08-.07.04-.11.09-.18.12-.11-.07-.21-.16-.2-.3l-.45.37-.02.07-1.33,1.11-.12.02-.03.34.87-.72v-.1s.09.07.09.07l.67-.54s.04.06.03.06c-.02,0-.6.54-.6.54l-.02.06-.1.09-.06-.04-.81.72h-.12s-.45.45-.45.45c-.12,0-.22.02-.31.09l-.8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M125.34,14.69s-.06,0-.1-.03l-.51-.6.81-.75c.1-.07.2-.08.33-.1l.43-.44h.14s.79-.72.79-.72l.09.04.08-.13c.45-.42.57-.52.6-.55h0s-.02-.01-.03-.03l-.64.54-.12-.08.04.08-.88.74v-.37s.13-.04.13-.04l1.32-1.1v-.06s.46-.39.46-.39c.03.15.13.23.23.29,0-.02.03-.04.06-.06.03-.02.06-.04.09-.06h-.04s-.12.06-.12.06l-.15-.14.13-.16-.8-.85s-.15.05-.25.04l-.3-.32v.47s-1.35,1.72-1.35,1.72l-.7-.79,1.18-1.7.22-.06s.16.03.28.03c.11,0,.13-.02.13-.03.07-.47.43-.39.57-.34l.52.56-.04.19h0s.78.86.8.89c.01-.02.15-.16.22-.22.03-.03.06-.06.07-.06l.08.09.03-.09.48-.47h.35s.41-.39.41-.39v-.26c.1.08.31.16.33.16.03-.05.08-.1.13-.1,0,0,.06.03.06.03.05.07.03.1.02.14l.04.05,1.67-1.2s.03,0,.03,0c0,0,0,.02,0,.03l-1.56,1.5c-.07.04-.15.02-.19-.02l-.91.8c-.1-.09-.16-.14-.25-.17l-.32.29c0,.07,0,.09-.06.15l-.22.24h0s2.9,3.3,2.93,3.33c0,.2-.05.24-.22.31l-3.02-3.41-.47.44-.26-.29v.1s.14.17.14.17c-.02.04-.17.06-.24.15-.03.04-.05.09-.04.15.02.17.8.31,1.29.37,0,.61,0,.61-.03.61-.05.02-.12.03-.2.03-.56,0-1.5-.59-1.53-.61l-.06.11.14.18-.36.42.17.56-.26.21-.24-.58-.13-.11.31-.32h.18s.08-.11.14-.19l-.1-.1-.1.11s0,.05.05.06c.01,0,.02.02.02.03,0,.01-.02.02-.03.02h-.13s-.58.51-.58.51c.01.03,0,.1-.06.18l-1.06,1.29s-.07.03-.1.03h0ZM127.23,12.1l-.78.72h-.14s-.43.45-.43.45c-.14.02-.23.03-.32.09l-.8.71.51.56s.08.03.13,0l1.05-1.28c.05-.06.06-.12.05-.16l.61-.55h.05s0,0,0,0c0-.02,0-.05.02-.09l.14-.11.14.14c-.16.23-.17.23-.18.23h-.16s-.3.28-.3.28l.14.08.21.58.22-.19-.17-.56.36-.41-.14-.18.09-.15h0s1,.6,1.54.6c.07,0,.14-.01.19-.03,0-.02,0-.34.01-.54-.11.01-1.28-.12-1.32-.39,0-.07,0-.14.05-.19.09-.11.25-.12.26-.12l-.15-.15.03-.13.27.28.47-.44,3.02,3.41c.13-.07.15-.1.16-.25-.01,0-.24-.26-2.92-3.34l.23-.27s.05-.06.05-.13l.35-.32c.12.03.2.09.26.18l.91-.81s.08.03.11.03l1.34-1.26-1.41.99-.09-.04s0-.06,0-.07c.01-.02.02-.04-.01-.08-.06-.01-.09.03-.12.06,0,0-.04.03-.04.03-.03,0-.26-.09-.32-.2l.03.26-.44.42h-.35s-.46.45-.46.45l-.05.17.07.13c-.25.25-.26.25-.28.25-.03-.03-.05-.05-.06-.06,0-.01-.02-.05-.01-.06l.22-.2v-.07s-.04-.12-.04-.12c0,.01-.02.02-.03.04-.18.18-.24.23-.27.23-.05-.04-.83-.92-.83-.92l.04-.19-.5-.53s-.1-.03-.17-.03c-.18,0-.29.12-.33.34-.02.05-.08.07-.18.07-.13,0-.28-.03-.28-.03l-.2.05-1.17,1.66.66.76,1.31-1.7.03-.47.33.3s.05,0,.08,0c.06,0,.11,0,.16-.03l.83.89-.13.17.06.03.06.07.03-.05.07-.05s.05.03.06.04l.03.04c-.04.06-.07.08-.09.1-.03.02-.06.04-.09.06-.14-.07-.25-.17-.24-.32l-.41.4v.06s-1.34,1.12-1.34,1.12l-.13.02v.32s.82-.74.82-.74v-.08s.12.05.12.05l.64-.54c.08.07.08.08.07.09-.04.03-.38.34-.61.55v.05s-.12.1-.12.1l-.09-.04h0ZM129.14,10.41v.03s-.23.21-.23.21c.04.02.06.03.06.05,0-.04.11-.13.21-.22l-.04-.06h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Malawi-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 165.24,
    y: -0.54,
    width: 41.7,
    height: 12.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 165.24,
    y: 11.63,
    width: 41.7,
    height: 12.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 165.24,
    y: 7.57,
    width: 41.7,
    height: 8.11
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M186.09,3.48c-2.28,0-4.21,1.46-4.93,3.49h9.86c-.72-2.03-2.65-3.49-4.93-3.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M186.09.44c-.18,0-.24.26-.24.53,0,.64.08.97.24,1.91.17-.94.24-1.27.24-1.91,0-.26-.07-.53-.24-.53M185.37.47c-.18.02-.22.28-.2.55.05.63.16.96.41,1.88.08-.95.13-1.29.08-1.92-.02-.26-.11-.52-.29-.5M186.81.47c-.18-.02-.26.24-.29.5-.06.63,0,.97.08,1.92.25-.92.35-1.25.41-1.88.02-.26-.02-.53-.2-.55M184.69.56s-.02,0-.03,0c-.17.03-.19.3-.15.56.11.62.24.94.57,1.83,0-.95.02-1.29-.09-1.92-.04-.24-.14-.48-.3-.48M187.5.56c-.16,0-.26.24-.3.48-.11.63-.09.97-.09,1.92.32-.89.46-1.21.57-1.83.05-.26.03-.53-.15-.56-.01,0-.02,0-.03,0M183.98.71s-.02,0-.03,0c-.17.05-.17.32-.1.57.16.61.33.92.73,1.78-.08-.95-.09-1.29-.26-1.91-.06-.24-.19-.46-.34-.45M188.2.71c-.15-.01-.28.21-.34.45-.16.61-.17.96-.26,1.91.4-.86.57-1.17.73-1.78.07-.25.07-.53-.1-.57-.01,0-.02,0-.03,0M183.32.93s-.04,0-.06,0c-.16.06-.14.33-.05.58.22.6.4.88.88,1.71-.17-.94-.21-1.28-.42-1.88-.08-.22-.21-.41-.35-.42M188.86.93c-.14,0-.27.2-.35.42-.22.6-.26.94-.42,1.88.48-.83.66-1.11.88-1.71.09-.25.12-.52-.05-.58-.02,0-.04,0-.06,0M182.65,1.2s-.04,0-.06.02c-.16.07-.11.34,0,.58.27.58.48.84,1.03,1.62-.25-.92-.32-1.25-.59-1.83-.1-.21-.24-.4-.38-.39M189.53,1.2c-.14,0-.29.18-.38.39-.27.58-.34.91-.59,1.83.55-.78.76-1.05,1.03-1.62.11-.24.16-.51,0-.58-.02,0-.04-.01-.06-.02M182.01,1.52s-.04,0-.06.02c-.15.09-.08.35.05.58.32.55.55.8,1.16,1.53-.33-.89-.42-1.22-.74-1.77-.12-.2-.27-.37-.41-.36M190.14,1.52c-.13,0-.28.17-.39.36-.32.55-.42.88-.74,1.77.61-.73.85-.98,1.16-1.53.13-.23.2-.49.05-.58-.03-.02-.06-.02-.09-.02M181.43,1.9s-.06,0-.09.03c-.14.1-.05.36.1.57.36.52.62.75,1.29,1.42-.4-.86-.53-1.18-.89-1.7-.12-.17-.28-.33-.42-.32M190.75,1.9c-.13,0-.29.15-.42.32-.36.52-.49.84-.89,1.7.67-.67.93-.9,1.29-1.42.15-.22.25-.47.1-.57-.03-.02-.05-.03-.09-.03M180.86,2.34s-.06.02-.08.04c-.13.11-.02.36.15.56.41.49.68.69,1.41,1.3-.48-.83-.63-1.13-1.04-1.62-.14-.16-.31-.3-.44-.28M191.29,2.34c-.13,0-.28.13-.41.28-.41.49-.56.79-1.04,1.62.73-.61,1-.82,1.41-1.3.17-.2.29-.45.15-.56-.03-.03-.07-.04-.11-.04M180.35,2.81s-.08.02-.11.05c-.12.12.01.36.2.54.45.45.74.63,1.52,1.18-.55-.78-.73-1.07-1.18-1.52-.14-.14-.31-.25-.43-.25M191.83,2.81c-.13,0-.29.11-.43.25-.45.45-.63.74-1.18,1.52.78-.55,1.07-.73,1.52-1.18.19-.19.32-.42.2-.54-.03-.03-.07-.05-.11-.05M179.9,3.33c-.06,0-.1.02-.14.06-.11.13.04.35.25.52.49.41.79.56,1.62,1.04-.61-.73-.82-1-1.3-1.41-.14-.12-.3-.21-.42-.21M192.29,3.33c-.12,0-.28.09-.42.21-.49.41-.69.68-1.3,1.41.83-.48,1.13-.63,1.62-1.04.2-.17.36-.39.25-.52-.04-.04-.08-.06-.14-.06M179.45,3.89c-.06,0-.1.03-.14.07-.1.14.08.35.29.5.52.36.84.49,1.7.89-.67-.67-.9-.92-1.42-1.29-.15-.1-.32-.18-.44-.17M192.7,3.89c-.12,0-.27.08-.4.17-.52.36-.75.62-1.42,1.29.86-.4,1.18-.53,1.7-.89.22-.15.4-.36.3-.5-.04-.05-.1-.07-.17-.07M179.09,4.49c-.07,0-.13.03-.16.08-.09.15.11.34.34.47.55.32.88.42,1.77.74-.73-.61-.98-.85-1.53-1.16-.14-.08-.3-.14-.42-.14M193.09,4.49c-.12,0-.27.06-.41.14-.55.32-.8.55-1.53,1.16.9-.33,1.22-.42,1.77-.74.23-.13.42-.32.33-.47-.03-.06-.09-.08-.16-.08M178.82,5.11c-.11,0-.19.02-.23.1-.07.16.14.33.38.44.58.27.91.34,1.83.58-.78-.55-1.05-.76-1.62-1.03-.12-.06-.25-.1-.35-.1M193.36,5.11c-.11,0-.23.04-.35.1-.58.27-.84.48-1.63,1.03.92-.25,1.25-.32,1.83-.58.24-.11.45-.28.38-.44-.04-.08-.12-.11-.23-.1M178.54,5.76c-.11,0-.19.04-.22.12-.06.17.16.32.41.41.6.22.94.26,1.88.42-.83-.48-1.11-.66-1.71-.88-.12-.04-.25-.08-.36-.07M193.65,5.76c-.11,0-.24.03-.36.07-.6.22-.88.4-1.71.88.94-.16,1.28-.21,1.88-.42.25-.09.47-.24.41-.41-.03-.08-.11-.12-.22-.12M178.39,6.43c-.15,0-.26.04-.29.14-.05.17.19.3.45.37.04,0,.07.02.1.03h1.3c-.51-.24-.8-.37-1.28-.5-.1-.02-.19-.04-.28-.04M193.79,6.43c-.09,0-.19.02-.28.04-.48.13-.77.26-1.28.5h1.3s.07-.02.1-.03c.26-.07.49-.2.45-.37-.03-.11-.15-.15-.29-.14"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Botswana-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 206.94,
    y: -0.54,
    width: 41.85,
    height: 9.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 206.94,
    y: 8.49,
    width: 41.85,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 206.94,
    y: 14.84,
    width: 41.85,
    height: 9.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 206.94,
    y: 13.49,
    width: 41.85,
    height: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 206.94,
    y: 9.46,
    width: 41.85,
    height: 4.42
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MAURITIUS-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 248.79,
    y: -0.54,
    width: 41.85,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 248.79,
    y: 5.57,
    width: 41.85,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 248.79,
    y: 11.67,
    width: 41.85,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 248.79,
    y: 17.77,
    width: 41.85,
    height: 6.1
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 144.61,
    y: 23.88,
    width: 40.21,
    height: 24.34
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "144.61 26.53 144.61 45.71 158.97 36.1 144.61 26.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "184.82 33.71 163.97 33.71 149.12 23.88 144.61 23.88 144.61 26.8 158.45 36.11 144.61 45.39 144.61 48.22 149.34 48.22 163.67 38.54 184.82 38.54 184.82 33.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "184.82 23.88 152.08 23.88 164.22 31.91 184.82 31.91 184.82 23.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "184.82 40.24 164.22 40.24 152.14 48.22 184.82 48.22 184.82 40.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "144.61 28.83 144.61 43.4 155.52 36.11 144.61 28.83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NAMIBIA-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "184.82 23.82 184.82 48.23 226.67 23.82 184.82 23.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "226.67 23.82 184.82 48.23 226.67 48.23 226.67 23.82"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "187.01 51.98 182.63 44.47 224.48 20.07 228.86 27.58 187.01 51.98 187.01 51.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "186.47 51.04 183.18 45.41 225.03 21.01 228.31 26.64 186.47 51.04 186.47 51.04"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "197.18 32.57 195.38 32.26 195.69 34.06 194.29 32.89 193.65 34.6 193.02 32.89 191.62 34.06 191.93 32.26 190.13 32.57 191.3 31.17 189.59 30.53 191.3 29.9 190.13 28.5 191.93 28.81 191.62 27.01 193.02 28.18 193.65 26.47 194.29 28.18 195.69 27.01 195.38 28.81 197.18 28.5 196.01 29.9 197.72 30.53 196.01 31.17 197.18 32.57"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M196.1,30.53c0,1.35-1.09,2.44-2.44,2.44-1.35,0-2.44-1.09-2.44-2.44s1.09-2.44,2.44-2.44c1.35,0,2.44,1.09,2.44,2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M195.69,30.53c0,1.12-.91,2.03-2.03,2.03-1.12,0-2.03-.91-2.03-2.03s.91-2.03,2.03-2.03,2.03.91,2.03,2.03"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ZIMBABWE-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 226.49,
    y: 23.85,
    width: 41.85,
    height: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 226.49,
    y: 27.34,
    width: 41.85,
    height: 17.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 226.49,
    y: 30.82,
    width: 41.85,
    height: 10.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 226.49,
    y: 34.31,
    width: 41.85,
    height: 3.49
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "226.49 23.85 226.49 48.25 227.37 48.25 243.63 36.05 227.37 23.85 226.49 23.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "226.49 23.85 226.49 48.25 242.75 36.05 226.49 23.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "233.07 29.85 230.33 35.41 234.49 37.47 233.07 29.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "233.07 29.85 235.81 35.41 231.64 37.47 233.07 29.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "233.07 29.85 230.99 35.69 235.37 37.25 233.07 29.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "233.07 29.85 235.14 35.69 230.77 37.25 233.07 29.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "238.96 34.14 232.83 33.25 232.16 37.85 238.96 34.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "227.18 34.14 233.31 33.25 233.97 37.85 227.18 34.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "238.96 34.14 232.77 33.97 232.64 38.61 238.96 34.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "227.18 34.14 233.37 33.97 233.5 38.61 227.18 34.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "236.2 40.36 235.11 35.15 232.5 35.69 236.2 40.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "236.2 40.36 231.58 37.72 232.9 35.41 236.2 40.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "229.94 40.36 234.56 37.72 233.24 35.41 229.94 40.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "229.94 40.36 231.02 35.15 233.63 35.69 229.94 40.36"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M235.19,39.92c0-.78.14-1.53.42-2.33.13-.36.47-1.1.56-1.21,0-.01.15.02.32.06.34.1.44.08.44-.08,0-.09-.35-.4-2.06-1.83-1.15-.96-2.1-1.72-2.14-1.72s-.09-.03-.1-.06c-.01-.03-.07-.4-.12-.83-.06-.43-.14-.84-.17-.93-.11-.26-.33-.39-.69-.41-.27-.02-.33,0-.51.1-.12.07-.27.12-.37.12-.2,0-.37.16-.37.35v.13s.3,0,.3,0c.16,0,.25,0,.18.01-.21.04-.13.34.12.43.27.1.26.04.26,1.3,0,1.03,0,1.18-.08,1.42-.11.35-.11.87,0,1.21.04.14.08.27.08.29,0,.02-.13.19-.28.38-.28.34-.46.7-.46.96,0,.06-.04.16-.08.22-.1.15-.11.4,0,.5.11.1.54,1.89.54,2.23,0,.12.02.12.68-.02.53-.11,1.79-.14,2.43-.05.29.04.64.11.76.14.39.11.37.13.37-.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.66,40.18c-.58-.14-1.24-.19-1.98-.16-.37.02-.77.05-.87.07l-.19.04-.05-.32c-.03-.17-.04-.32-.03-.33,0,0,.19-.04.4-.07.74-.11,2.31-.07,3.04.08l.13.03v.38c0,.28-.01.38-.05.38-.03,0-.21-.04-.4-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M231.03,40.21c0-.09-.23-1.19-.33-1.58-.07-.26-.12-.5-.12-.52,0-.02.06,0,.14.06.08.05.17.1.22.1.21,0,.33.32.51,1.4.03.15.05.32.07.37.02.09,0,.11-.19.15-.23.06-.29.06-.29.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M235.05,39.37s0-.07.04-.1c.05-.05.06-.04.06.02,0,.08-.07.14-.1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M231.74,39.19c.11-.12.11-.12.2-.04.08.08.08.09.01.12-.04.02-.13.03-.2.04h-.12s.11-.12.11-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.46,39.26s.05-.08.1-.11c.07-.05.09-.04.15.05l.07.11h-.17c-.11,0-.16-.02-.15-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.83,39.2c-.05-.07-.08-.13-.07-.14,0,0,.09,0,.19.02l.18.03-.1.11-.1.11-.09-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M231.46,39.2c-.03-.09.04-.16.16-.16.09,0,.09,0-.03.13-.09.1-.1.1-.13.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M232.42,39.12l.11-.13.11.1c.06.06.11.11.12.11,0,0-.09.02-.21.02l-.23.02.11-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M233.88,39.23l-.14-.03.1-.1.1-.1.12.14c.13.15.12.16-.18.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M232.06,39.11l-.1-.12h.15c.08,0,.18-.01.22-.03.06-.03.05,0-.03.12-.05.08-.11.14-.12.14s-.07-.05-.12-.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M233.11,39.09l.12-.14.12.12c.06.07.12.13.12.14s-.11.01-.23.01h-.23s.12-.14.12-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.2,39.11l-.1-.12h.19c.21,0,.23.03.12.15-.1.1-.1.1-.21-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M232.76,39.06l-.1-.11h.22s.22,0,.22,0l-.1.11c-.12.14-.13.14-.25,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M233.5,39.06l-.1-.11h.22s.22,0,.22,0l-.1.11c-.12.14-.13.14-.25,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.82,38.95c-.1-.02-.51-.06-.91-.09-.69-.06-1.55-.03-2.31.08-.16.02-.2.01-.2-.04,0-.12.83-.2,2.1-.2.62,0,1.26.02,1.41.04.26.03.28.05.28.15,0,.12-.03.13-.37.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M231.62,38.56c.08-.09.17-.16.19-.16s.08.05.13.11l.09.11-.2.03c-.11.02-.24.04-.28.05-.06.01-.04-.02.07-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M231.33,38.58c-.03-.09-.02-.12.05-.15.05-.02.12-.03.16-.02.07.01.06.03-.05.15l-.13.13-.04-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M235.15,38.63s.03-.05.06-.07c.04-.02.05,0,.04.04-.03.07-.1.09-.1.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M232.38,38.47c.06-.08.11-.14.11-.15,0,0,.06.05.13.12l.13.13-.24.02-.24.02.11-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.58,38.59l-.18-.02.13-.12.13-.12.1.11c.11.12.13.19.05.17-.03,0-.13-.02-.23-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M232.04,38.47l-.12-.11.2-.03c.11-.02.2-.03.21-.02,0,0-.03.07-.08.14l-.09.12-.12-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M233.84,38.54l-.1-.03.1-.11c.09-.09.11-.1.17-.05.04.03.08.1.11.14.03.07.02.08-.07.08-.06,0-.16-.02-.21-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.88,38.44l-.12-.14.1.03c.06.02.18.03.27.03h.16s-.12.11-.12.11c-.07.06-.13.11-.15.12-.01,0-.08-.06-.14-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M232.77,38.43c-.05-.06-.09-.12-.09-.14,0-.02.1-.03.23-.03h.23s-.08.1-.08.1c-.14.17-.2.18-.3.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M233.15,38.42c.13-.13.18-.13.26.02.06.1.06.1-.16.1h-.22s.12-.12.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.17,38.4l-.1-.14h.1c.06,0,.16.01.23.03l.13.03-.12.11c-.06.06-.12.11-.13.11,0,0-.06-.06-.11-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M233.5,38.38l-.1-.12h.22s.22,0,.22,0l-.1.12c-.12.14-.13.14-.25,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M231.3,38.23s.05-.18.08-.31l.05-.23.45-.25c.25-.14.53-.31.62-.39.09-.08.18-.16.21-.17.06-.04,1.26.05,1.79.13.41.07,1.12.21,1.14.23,0,0-.06.21-.14.46-.08.25-.16.48-.17.52-.01.05-.06.05-.2.03-.68-.11-2.63-.1-3.38.02-.43.07-.49.06-.45-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M234.74,37.95c.27-.3.08-.78-.29-.78-.24,0-.41.19-.41.46,0,.42.44.62.7.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.3,37.93c-.22-.12-.21-.53.02-.63.23-.1.46.06.46.32,0,.25-.27.43-.48.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M233.09,37.92c.25-.23.19-.64-.1-.78-.19-.09-.4-.02-.51.18-.12.22-.1.38.06.56.18.2.37.21.56.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M232.69,37.9c-.3-.14-.2-.69.13-.69.32,0,.43.5.14.67-.13.08-.15.08-.27.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M231.12,38.1c.06-.17.05-.39-.01-.39-.03,0-.05.06-.05.16,0,.09-.02.19-.05.22-.05.05-.05.01-.03-.21.01-.15,0-.26-.01-.26-.04,0-.11.22-.13.41q-.02.11-.05-.02c-.03-.1-.01-.17.05-.31.05-.09.09-.23.09-.31,0-.11.08-.22.46-.63.25-.27.55-.61.65-.75.18-.24.19-.27.19-.52,0-.14-.02-.27-.03-.29-.05-.05-.11.22-.09.37.02.14,0,.18-.27.52-.16.2-.43.51-.6.68-.32.32-.43.49-.43.65,0,.05-.04.18-.08.29-.04.11-.07.22-.06.25.01.03,0,.03-.03,0-.04-.04-.04-.1,0-.25.02-.11.03-.22.02-.24-.04-.08-.1.02-.12.24-.02.12-.04.21-.06.2-.06-.04-.04-.27.03-.38.04-.06.08-.2.1-.32.05-.32.18-.58.47-.92.14-.18.26-.33.26-.33,0,0-.04-.14-.09-.29-.11-.34-.12-.87-.02-1.19.1-.33.32-.67.65-1.02.35-.36.68-.58.84-.55.14.02,4.13,3.36,4.13,3.45,0,.04-.03.07-.07.06-.04,0-1.05-.31-2.25-.68-1.92-.6-2.19-.69-2.28-.8-.12-.15-.12-.38-.01-.54.05-.06.08-.14.08-.18,0-.1-.2.16-.24.31-.05.18.04.47.16.57.05.04.41.17.81.3.68.21.72.24.76.36.09.29-.2.62-.61.72-.13.03-.3.12-.42.21-.46.37-.79.59-1.06.72-.16.07-.31.16-.34.19-.03.03-.07.16-.09.3-.05.28-.07.33-.15.33-.05,0-.05-.03-.02-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M235.3,37.05c-.42-.1-1.09-.2-1.77-.26l-.65-.06.25-.1c.14-.05.33-.15.43-.21.16-.1.23-.11.47-.09.37.03.62-.04.71-.21.04-.07.08-.13.08-.14,0,0,.3.07.65.18l.64.2-.12.23c-.07.13-.15.3-.19.38-.08.17-.1.17-.48.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M233.85,36.21s-.03-.05,0-.11c.03-.05.06-.07.08-.03.04.07-.03.19-.09.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234,36.2c0-.06.03-.06.06,0,.01.03,0,.05-.02.05s-.04-.02-.04-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.2,36.18s.02-.06.04-.04c.05.04.05.11,0,.11-.02,0-.04-.03-.04-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.4,36.17s-.03-.06-.03-.1c0-.05.01-.06.05-.02.02.03.04.07.03.1,0,.03-.03.04-.05.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.07,36.08s-.03-.07-.03-.1c0-.05.01-.06.05-.02.03.03.04.08.03.1,0,.03-.03.04-.05.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.55,36.06c-.04-.08,0-.1.06-.02.03.04.04.07,0,.07-.02,0-.06-.02-.07-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.23,35.98s0-.05.02-.07c.02-.02.04,0,.04.04,0,.08-.02.09-.06.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.41,35.9s.02-.06.04-.04c.05.04.05.11,0,.11-.02,0-.04-.03-.04-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M233.92,35.86c0-.08.02-.09.06-.03.01.02,0,.05-.02.07-.02.02-.04,0-.04-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M234.08,35.81s.02-.06.04-.04c.05.04.05.12,0,.12-.02,0-.04-.03-.04-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M231.31,33.61c-.01-.2-.01-.66,0-1.03.02-.76,0-.83-.23-.92-.19-.07-.26-.12-.26-.21,0-.06.04-.07.25-.04.22.03.25.02.24-.05-.02-.12-.31-.21-.61-.19-.24.01-.27,0-.25-.06.03-.14.17-.23.37-.25.11-.01.27-.06.35-.11.13-.08.22-.09.46-.08.54.03.64.19.78,1.22.05.4.1.77.1.82,0,.07-.07.15-.26.29-.28.2-.64.56-.81.82l-.1.15-.02-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M231.71,31.21c.06-.08.07-.11.03-.21-.06-.14-.13-.11-.1.05.02.09,0,.12-.07.12s-.09-.03-.09-.14,0-.13-.06-.08c-.08.07-.08.18,0,.28.09.11.19.11.28,0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "MOZAMBIQUE-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 268.33,
    y: 23.85,
    width: 41.85,
    height: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 268.33,
    y: 23.85,
    width: 41.85,
    height: 8.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 268.33,
    y: 23.85,
    width: 41.85,
    height: 7.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 268.33,
    y: 39.86,
    width: 41.85,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 268.33,
    y: 40.63,
    width: 41.85,
    height: 7.63
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "268.33 23.85 268.33 48.25 284.35 36.05 268.33 23.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "276.64 40.63 273.67 38.45 270.7 40.63 271.85 37.13 268.86 34.97 272.55 34.99 273.67 31.48 274.8 34.99 278.48 34.97 275.49 37.13 276.64 40.63"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M271.09,38.18h2.14c.17.19.56.27.92,0,.67-.37,1.97,0,1.97,0l.26-.27-.62-2.05-.22-.24s-.48-.29-1.39-.19c-.91.1-1.23-.03-1.23-.03,0,0-.8.09-1.02.21-.02.02-.26.26-.26.26l-.54,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M273.66,38.39h0c-.18,0-.35-.07-.45-.18h-2.12s.52-2.34.52-2.34c0-.01.24-.25.27-.27.23-.12,1-.21,1.04-.21.02,0,.34.12,1.23.03.91-.1,1.39.19,1.41.2l.23.24.63,2.06-.26.3s-.61-.16-1.18-.16c-.33,0-.6.05-.79.16-.16.12-.33.18-.51.18h0ZM273.23,38.16c.11.11.27.18.43.18h0c.16,0,.33-.06.48-.17.2-.11.48-.17.82-.17.58,0,1.17.17,1.17.17l.23-.26-.63-2.02-.22-.23h0s-.49-.28-1.37-.19c-.91.1-1.24-.03-1.24-.03,0,0-.79.1-1,.21-.02.02-.25.25-.25.25l-.54,2.31,2.12-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M273.64,38.39c-.15,0-.3-.06-.45-.16.04-.08.19-.24.47-.38-.81-.32-2.13-.16-2.15-.16-.02,0-.03,0-.03-.02,0-.01,0-.03.02-.03.07,0,1.38-.17,2.2.19.4-.19,1.05-.34,1.99-.21.01,0,.02.02.02.03,0,.02-.01.03-.03.02-.92-.13-1.54.01-1.92.18.17.08.31.18.41.32-.19.15-.36.22-.53.22h0ZM273.73,37.87c-.35.16-.49.34-.49.35.29.18.57.18.91-.05-.1-.12-.24-.22-.41-.3h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "273.71 37.86 273.69 35.61 273.73 35.61 273.71 37.86 273.71 37.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "275.94 37.43 275.51 35.65 275.55 35.64 275.94 37.43 275.94 37.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M271.69,36.56s0,0,0,0c-.01,0-.02-.02-.02-.03l.21-.92s.02-.02.03-.02c.01,0,.02.02.02.03l-.21.92s-.01.02-.02.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M269.69,38.43l.5.59c.06.03.11.03.17,0l.75-.9.31-.39c.05-.06.06-.12.06-.18l.6-.53s.08,0,.13.01c-.06-.01-.1-.04-.06-.11l.13-.1.1.13s-.15.19-.16.19h-.16s-.31.28-.31.28l.14.12.21.57.25-.18-.16-.58.36-.39-.13-.21.09-.12s1.24.78,1.72.57c.01,0,.03-.56.03-.56,0,0-1.29-.13-1.31-.39-.03-.25.28-.28.28-.28l-.13-.19.03-.1.22.28.51-.43,2.99,3.41c.16-.07.2-.11.21-.27,0,0-2.93-3.36-2.93-3.36l.22-.24s.06-.07.06-.15l.34-.3c.1.04.17.1.22.18l.95-.8s.1.05.15.02l1.56-1.5-1.7,1.2-.06-.04s.06-.06,0-.15c-.07-.08-.16.07-.18.07s-.25-.08-.3-.19l-.02.27-.43.4-.33-.02-.48.46-.06.18.07.15s-.25.22-.25.21-.05-.07-.05-.07l.22-.2.03-.13-.07-.11s-.3.31-.32.28c-.02-.03-.81-.91-.81-.91l.05-.16-.51-.55c-.19-.06-.48-.07-.54.33-.05.09-.43.02-.43.02l-.21.05-1.18,1.67.66.79,1.34-1.7.04-.48.28.31c.09.01.18.01.27-.03l.8.89-.13.13s.08.08.12.13c.04-.03.09-.07.13-.1.02.02.04.06.05.08-.07.04-.11.09-.18.12-.11-.07-.21-.16-.2-.3l-.45.37-.02.07-1.33,1.11-.12.02-.03.34.87-.72v-.1s.09.07.09.07l.67-.54s.04.06.03.06c-.02,0-.6.54-.6.54l-.02.06-.1.09-.06-.04-.81.72h-.12s-.45.45-.45.45c-.12,0-.22.02-.31.09l-.8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M270.28,39.07s-.06,0-.1-.03l-.51-.6.81-.75c.1-.07.2-.08.33-.1l.43-.44h.14s.79-.72.79-.72l.09.04.08-.13c.45-.42.57-.52.6-.55h0s-.02-.01-.03-.03l-.64.54-.12-.08.04.08-.88.74v-.37s.13-.04.13-.04l1.32-1.1v-.06s.46-.39.46-.39c.03.15.13.23.23.29,0-.02.03-.04.06-.06.03-.02.06-.04.09-.06h-.04s-.12.06-.12.06l-.15-.14.13-.16-.8-.85s-.15.05-.25.04l-.3-.32v.47s-1.35,1.72-1.35,1.72l-.7-.79,1.18-1.7.22-.06s.16.03.28.03c.11,0,.13-.02.13-.03.07-.47.43-.39.57-.34l.52.56-.04.19h0s.78.86.8.89c.01-.02.15-.16.22-.22.03-.03.06-.06.07-.06l.08.09.03-.09.48-.47h.35s.41-.39.41-.39v-.26c.1.08.31.16.33.16.03-.05.08-.1.13-.1,0,0,.06.03.06.03.05.07.03.1.02.14l.04.05,1.67-1.2s.03,0,.03,0c0,0,0,.02,0,.03l-1.56,1.5c-.07.04-.15.02-.19-.02l-.91.8c-.1-.09-.16-.14-.25-.17l-.32.29c0,.07,0,.09-.06.15l-.22.24h0s2.9,3.3,2.93,3.33c0,.2-.05.24-.22.31l-3.02-3.41-.47.44-.26-.29v.1s.14.17.14.17c-.02.04-.17.06-.24.15-.03.04-.05.09-.04.15.02.17.8.31,1.29.37,0,.61,0,.61-.03.61-.05.02-.12.03-.2.03-.56,0-1.5-.59-1.53-.61l-.06.11.14.18-.36.42.17.56-.26.21-.24-.58-.13-.11.31-.32h.18s.08-.11.14-.19l-.1-.1-.1.11s0,.05.05.06c.01,0,.02.02.02.03,0,.01-.02.02-.03.02h-.13s-.58.51-.58.51c.01.03,0,.1-.06.18l-1.06,1.29s-.07.03-.1.03h0ZM272.17,36.49l-.78.72h-.14s-.43.45-.43.45c-.14.02-.23.03-.32.09l-.8.71.51.56s.08.03.13,0l1.05-1.28c.05-.06.06-.12.05-.16l.61-.55h.05s0,0,0,0c0-.02,0-.05.02-.09l.14-.11.14.14c-.16.23-.17.23-.18.23h-.16s-.3.28-.3.28l.14.08.21.58.22-.19-.17-.56.36-.41-.14-.18.09-.15h0s1,.6,1.54.6c.07,0,.14-.01.19-.03,0-.02,0-.34.01-.54-.11.01-1.28-.12-1.32-.39,0-.07,0-.14.05-.19.09-.11.25-.12.26-.12l-.15-.15.03-.13.27.28.47-.44,3.02,3.41c.13-.07.15-.1.16-.25-.01,0-.24-.26-2.92-3.34l.23-.27s.05-.06.05-.13l.35-.32c.12.03.2.09.26.18l.91-.81s.08.03.11.03l1.34-1.26-1.41.99-.09-.04s0-.06,0-.07c.01-.02.02-.04-.01-.08-.06-.01-.09.03-.12.06,0,0-.04.03-.04.03-.03,0-.26-.09-.32-.2l.03.26-.44.42h-.35s-.46.45-.46.45l-.05.17.07.13c-.25.25-.26.25-.28.25-.03-.03-.05-.05-.06-.06,0-.01-.02-.05-.01-.06l.22-.2v-.07s-.04-.12-.04-.12c0,.01-.02.02-.03.04-.18.18-.24.23-.27.23-.05-.04-.83-.92-.83-.92l.04-.19-.5-.53s-.1-.03-.17-.03c-.18,0-.29.12-.33.34-.02.05-.08.07-.18.07-.13,0-.28-.03-.28-.03l-.2.05-1.17,1.66.66.76,1.31-1.7.03-.47.33.3s.05,0,.08,0c.06,0,.11,0,.16-.03l.83.89-.13.17.06.03.06.07.03-.05.07-.05s.05.03.06.04l.03.04c-.04.06-.07.08-.09.1-.03.02-.06.04-.09.06-.14-.07-.25-.17-.24-.32l-.41.4v.06s-1.34,1.12-1.34,1.12l-.13.02v.32s.82-.74.82-.74v-.08s.12.05.12.05l.64-.54c.08.07.08.08.07.09-.04.03-.38.34-.61.55v.05s-.12.1-.12.1l-.09-.04h0ZM274.08,34.8v.03s-.23.21-.23.21c.04.02.06.03.06.05,0-.04.11-.13.21-.22l-.04-.06h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "MAURITIUS-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: -13.36,
    y: 23.9,
    width: 41.85,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: -13.36,
    y: 30,
    width: 41.85,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: -13.36,
    y: 36.1,
    width: 41.85,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: -13.36,
    y: 42.21,
    width: 41.85,
    height: 6.1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_5-2",
    className: "cls-39",
    d: "M28.5,23.88h48.89s0,24.44,0,24.44H28.5s0-24.44,0-24.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_4-4",
    className: "cls-24",
    d: "M28.5,23.88h32.59s-32.59,24.44-32.59,24.44v-24.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3-4",
    className: "cls-9",
    d: "M77.38,32.03v16.3s-48.89,0-48.89,0l48.89-16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2-4",
    className: "cls-20",
    d: "M28.5,23.88h16.3s-16.3,24.44-16.3,24.44v-24.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1-4",
    className: "cls-27",
    d: "M28.5,48.32h48.89s0-8.15,0-8.15l-48.89,8.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_4-5",
    className: "cls-13",
    d: "M114.02,31.19c-12.21,0-24.42,0-36.64,0,0-2.44,0-4.87,0-7.31,12.21,0,24.42,0,36.64,0v7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3-5",
    className: "cls-45",
    d: "M77.38,40.98c12.21,0,24.42,0,36.64,0,0,2.44,0,4.89,0,7.33-12.21,0-24.42,0-36.64,0,0-2.44,0-4.89,0-7.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_2-5",
    className: "cls-9",
    x: 77.38,
    y: 31.19,
    width: 36.64,
    height: 9.78
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1-5",
    className: "cls-12",
    d: "M94.09,33.65c.01-.76.29-1.41.84-1.7.14-.07.24-.06.4-.13.11-.05.19-.18.35-.18.17,0,.24.11.35.18.81.12,1.14.73,1.25,1.56.01.06-.02.17.02.2v.05s0,.14-.02.2c-.08.72-.3,1.3-.55,1.85.62.88,1.28,1.71,1.92,2.57.12-.03.21-.1.33-.13.24.46.45.94.7,1.39-.89.59-2.04.91-3.41,1.03-.06.01-.16-.02-.18.02h-.18c-.18,0-.37,0-.55,0-1.45-.06-2.58-.44-3.57-.97.2-.51.45-.96.66-1.45.11.05.23.08.35.13.66-.8,1.26-1.67,1.89-2.51-.25-.58-.49-1.18-.57-1.92-.01-.06.02-.16-.02-.18ZM96.03,32.22s0-.01,0-.02c-.15.24.02.91-.02,1.23.17.21.39.38.59.57-.12.1-.33-.07-.44.02-.12.1.04.83,0,.92.07.16.18.28.29.4.19-.45.37-.91.42-1.5.03-.1.03-.34,0-.44-.07-.6-.27-1.08-.84-1.17ZM95.37,32.75v-.53c-.55.12-.8.54-.86,1.15-.03.11-.03.35,0,.46.06.61.23,1.11.46,1.56.04-.17.26-.26.31-.46.06-.27-.05-.56,0-.88h-.46c.09-.12.22-.2.29-.33.07-.05.13-.11.18-.18.03-.02.07-.04.07-.09.03-.19.03-.51,0-.7ZM98.19,38.8c.07.15.2.24.27.38.14-.11.22-.28.31-.44-.09-.28-.39.02-.59.05ZM92.81,39.11c-.07-.1-.07-.27-.15-.37-.07.16-.16.29-.22.46.12-.03.27-.03.37-.09ZM93.04,38.76c.06.19.12.37.18.55.17-.04.34-.07.48-.15-.06-.29-.37-.34-.66-.4ZM97.29,39.07c.06.15.17.26.27.37.14-.17.66-.35.27-.51-.2.03-.35.12-.55.15ZM98.69,39.46c.15-.01.23-.09.37-.11-.04-.14-.12-.23-.16-.37-.1.12-.27.25-.2.48ZM94.02,39.04c.05.19.14.34.2.51.19-.03.31-.12.48-.16-.06-.28-.39-.29-.68-.35ZM96.25,39.22c.09.12.15.27.24.38.16-.1.35-.16.51-.26-.03-.34-.5-.18-.75-.13ZM95.26,39.2s-.18,0-.26-.02c0,.02,0,.05.02.05.08.14.15.31.26.42.2-.11.48-.15.66-.27-.04-.04-.06-.1-.07-.16h-.2s-.16,0-.24-.02h-.16ZM92.9,39.29c-.12-.03-.24.08-.38.09.1.12.3.13.44.2,0-.12-.05-.18-.05-.29ZM98.36,39.66c-.02-.12-.17-.28-.27-.38-.14.11-.3.2-.42.33.05.05.08.12.11.18.22-.02.37-.11.59-.13ZM93.74,39.37c-.13.05-.27.09-.4.13,0,.1.04.18.07.26.22.02.38.11.6.13-.09-.17-.14-.39-.27-.51ZM97.13,39.49c-.19.07-.35.17-.53.26.04.4.57.16.84.11-.11-.12-.21-.24-.31-.37ZM94.82,39.57c-.19.04-.33.12-.51.16.01.08.05.14.07.22.25.02.47.07.71.09-.07-.18-.2-.3-.27-.48ZM95.96,40.04h.38c-.07-.19-.2-.31-.29-.48-.23.07-.44.16-.66.24.02.11.09.17.13.26h.13c.1-.01.24.02.31-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2-3",
    className: "cls-25",
    d: "M114.02,23.81h30.64v24.51h-30.64v-24.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4-3",
    className: "cls-31",
    d: "M114.02,29.69h30.64v12.77h-30.64v-12.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6-3",
    className: "cls-16",
    d: "M114.02,30.96h30.64v10.21h-30.64v-10.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g19-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8-3",
    className: "cls-1",
    d: "M139.19,33.73l-1.24.44,1.24.44,1.24-.44-1.24-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect10-3",
    className: "cls-8",
    d: "M120.45,34.03h17.92c.09,0,.16.07.16.15h0c0,.08-.07.15-.16.15h-17.92c-.09,0-.16-.07-.16-.15h0c0-.08.07-.15.16-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12-3",
    className: "cls-8",
    d: "M138.09,34.32c.07,0,.15-.07.15-.15s-.07-.15-.15-.15M137.95,34.32c.07,0,.15-.07.15-.15s-.07-.15-.15-.15M137.8,34.32c.07,0,.15-.07.15-.15s-.07-.15-.15-.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "use15-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138,34.61l-1.24.44,1.24.44,1.24-.44-1.24-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M119.26,34.9h17.92c.09,0,.16.07.16.15h0c0,.08-.07.15-.16.15h-17.92c-.09,0-.16-.07-.16-.15h0c0-.08.07-.15.16-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M136.91,35.19c.07,0,.15-.07.15-.15s-.07-.15-.15-.15M136.76,35.19c.07,0,.15-.07.15-.15s-.07-.15-.15-.15M136.61,35.19c.07,0,.15-.07.15-.15s-.07-.15-.15-.15"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect17-3",
    className: "cls-6",
    d: "M117.29,35.85h24.37c.12,0,.22.1.22.22h0c0,.12-.1.22-.22.22h-24.37c-.12,0-.22-.1-.22-.22h0c0-.12.1-.22.22-.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path21-3",
    className: "cls-7",
    d: "M136.63,36.07c-1.46,1.46-3.4,4.38-7.3,4.38-3.4,0-5.84-2.92-7.3-4.38,1.46-1.46,3.89-4.38,7.3-4.38,3.89,0,5.84,2.92,7.3,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23-3",
    className: "cls-11",
    d: "M128.83,33.21c.39.44.06.61.47.64.43.03.19.46.55.48.25.01-.03,1.03.22,1.36.25.35.46.1.46.36,0,.26-.68.24-.69,1.04-.02.46-.58.49-.6.79-.03.28,1.1.44,1.08.69-.02.25-1.22.21-1.27.5-.03.26,1.66.47,1.79,1.21-.25.08-.97.16-1.51.16-3.4,0-5.84-2.92-7.29-4.38,1.46-1.46,3.89-4.38,7.3-4.38,0,0-1.01.92-.51,1.52h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g32-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b-3",
    className: "cls-10",
    d: "M124.94,35.68v-1.17M125.65,34.51v1.17M126.36,34.51v1.17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "use26-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M124.94,37.63v-1.17M125.65,36.46v1.17M126.36,36.46v1.17"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "use29-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M127.07,35.68v-1.17M127.77,34.51v1.17M128.48,34.51v1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M127.07,37.63v-1.17M127.77,36.46v1.17M128.48,36.46v1.17"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "use34-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.29,35.68v-1.17M131,34.51v1.17M131.71,34.51v1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.29,37.63v-1.17M131,36.46v1.17M131.71,36.46v1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.42,35.68v-1.17M133.12,34.51v1.17M133.83,34.51v1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.42,37.63v-1.17M133.12,36.46v1.17M133.83,36.46v1.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36-3",
    className: "cls-3",
    d: "M140.13,35.9c-.22.38.17-.13,1.12.51.18.12.33.43.33.65-.04-.03-.08-.1-.13-.14-.07.07.07.39.09.54-.15-.08-.13-.12-.18-.23,0,.12-.03.47.03.6-.12-.03-.11-.13-.17-.15.04.15-.04.31-.02.48-.07-.07-.14-.12-.17-.15,0,.08-.13.29-.13.36-.06-.04-.07-.09-.08-.13-.07.09-.33.43-.35.53-.2-.18-.71-.6-.77-.83-.06.13-.14.17-.31.27-.07-.36-.31-.76-.18-1.07-.09.06-.17.11-.26.18.09-.52.54-1.13,1.19-1.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38-3",
    className: "cls-41",
    d: "M139.31,37.79c.09-.18.18-.24.24-.36.1-.21.12-.37.21-.35.09.02.09.11-.03.31-.12.2-.17.25-.42.39ZM139.93,38.23c-.01-.14.03-.2.02-.29-.01-.16-.08-.27,0-.27.08,0,.12.05.12.21,0,.16-.02.2-.15.36h0ZM140.4,38.5c-.04-.19,0-.28-.03-.41-.04-.22-.12-.37-.04-.39s.13.05.15.28c.03.22.01.29-.08.52h0ZM140.89,37.14c-.12-.09-.18-.09-.26-.15-.13-.1-.2-.2-.24-.15-.04.05-.01.11.12.2.14.09.18.1.37.1h0ZM140.81,37.78c-.06-.13-.12-.16-.16-.24-.07-.14-.07-.27-.14-.23-.08.03-.08.1,0,.23.08.14.12.16.31.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40-3",
    className: "cls-5",
    d: "M118.14,36.26c-.01-.11.01-.12-.06-.21.1.04.1.15.23.07.04-.02.06-.02,0-.15.13,0,.54.15.61.15.17,0,.49-.18.71.05.21.21.14.44.14.73-.09-.04-.04-.06-.13-.17.07.26,0,.73,0,1-.03-.07-.03-.04-.06-.11-.09.25-.2.3-.2.6-.03-.12,0-.09-.04-.15-.09.19-.68.35-.45.55-.2-.12-.29-.11-.39-.22-.04.03-.07.07-.11.14-.36-.17-.23-.52-.51-.76-.05.1-.03.09-.08.25-.06-.23-.07-.37-.14-.54-.06.09-.05.06-.15.2-.04-.28-.11-.34-.08-.52-.11.08-.04.04-.14.14.1-.71.54-1.23.85-1.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42-3",
    className: "cls-41",
    d: "M117.7,37.42c.09-.23.18-.3.24-.45.11-.26.12-.46.21-.43.09.03.09.14-.03.39-.12.25-.17.31-.42.49h0ZM118.05,37.99c.04-.2.1-.28.12-.41.04-.23.02-.4.1-.39.08,0,.1.1.05.33-.06.23-.09.28-.27.48h0ZM118.47,38.38c.01-.2.06-.27.06-.4.01-.22-.03-.38.05-.39.08,0,.11.08.08.3-.02.22-.05.28-.19.48h0ZM119.38,37.09c-.17-.17-.28-.2-.39-.31-.2-.19-.29-.38-.36-.31-.07.06-.03.16.18.35.21.18.28.21.57.28ZM119.27,37.75c-.11-.17-.19-.22-.27-.33-.13-.2-.17-.36-.24-.32-.07.04-.06.13.08.32.14.19.19.22.43.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44-3",
    className: "cls-4",
    d: "M126.98,32.47c-.2.39.35-.13,1.23.52.16.12.39.6.39.82-.19-.04-.51-.22-.51-.22,0,0,.39.39.39.83-.14-.09-.2-.07-.25-.18,0,.14.12.24.12.46-.08-.07-.17-.13-.26-.18.13.22-.23.65-.05.8-.32-.05-.64-.25-.77-.47-.07.05-.08.12-.08.19.01,0-.48-.37-.44-.51-.07.09-.08.14-.09.25-.18-.18-.35-.36-.41-.59-.08.1-.09.1-.17.21-.06-.37-.06-.35.06-.67-.09.06-.16.11-.24.18.08-.53.49-1.15,1.09-1.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46-3",
    className: "cls-41",
    d: "M126.48,34.38c.03-.27.1-.37.12-.54.04-.31,0-.53.1-.52.11,0,.14.12.09.42-.05.3-.1.38-.31.64h0ZM127.05,34.87c-.02-.23.02-.32,0-.47-.02-.26-.1-.43,0-.45.09-.02.14.07.15.33.01.26-.02.33-.15.59h0ZM127.93,35.27c-.1-.2-.18-.26-.24-.38-.11-.22-.13-.4-.22-.37-.08.03-.08.13.04.34.12.22.18.26.41.41ZM128.23,33.51c-.24-.13-.37-.13-.53-.21-.28-.14-.44-.31-.5-.22-.06.09.02.18.3.31.29.13.37.14.72.12h0ZM128.32,34.25c-.18-.15-.28-.17-.4-.26-.2-.17-.3-.33-.37-.26-.07.07-.02.15.19.31.21.16.28.18.58.22h0Z"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 0,
    y: 0,
    width: 284.84,
    height: 46.86,
    rx: 23.43,
    ry: 23.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.aac37eaa8478781e8a170ed63b2ac9d7.svg";
export { ForwardRef as ReactComponent };